import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class FrmService {
  //public conditionOps=['E','G','A','F','P'];
  public secDataSet={
    "frm_sec0": {
      'AccountNameHTML':[],
      'PropertyAsReported':[],
      'PropertyAsReportedHTML':[],
      'PropertyConditionAssessmentHTML':[],
      'PropertyConditionAssessmentPropertyCoreCharacteristics':[],
      'PropertyConditionAssessmentPropertyCoreCharacteristicsHTML':[],
      
      'PropertyAmenity':[],
      'PropertyTotalRentRollSummary':[],        
      'ListOfParties':[],
      'PropertyConditionAssessment':[
        "FirmCityName",
        "FinalAsmntDate",
        "FirmStateUspsCode",
        "FirmPostalCode",
        "InspectorTitle",
        "OnsiteContactName",
			  "InspectorPhoneNumber",
        "FirmName",
        "InspectorName",
        "AtInpectionWeatherDescription",
        "FirmAddressLineText",
        "OnsiteContactPhoneNumber",
			  "PrelimInspectionDate",
        'PropertyConditionAssessmentBuildingAndMaterials',
        "RsdntlOtherInspectedUnitCount",		
        "RsdntlDownInspectedUnitCount",			
        "RsdntlVacantInspectedUnitCount",
        "RsdntlOccupiedInspectedUnitCount",
        'PropertySeismicRiskAssessment',
      ],
      'firmname':[],
      'frmSign':[],
      'date':[],
      'frmSignName':[],
      'title':[],
    },
    "frm_sec1": {
      'overallPropertyRating':[
        'overallCondition',
        'overallRating'
      ]
    },
    "frm_sec2": {
      'repairtCount':[]
    },
    "frm_sec3": {
      'waterCheck':[],
      'PropertyConditionAssessment':[
        'PropertyConditionAssessmentWaterTreatment'
      ],
      'flatPartySetSec3':[]      
      },
    "frm_sec4": {
       'PropertyConditionAssessment':[
          "PropertyConditionAssessmentManufacturedHousing",
          "ManufacturedHousingInd",
          "ManufacturedHousingPadSiteSizeDescription",
          "ManufacturedHousingUtility"
        ],       
      'sec4OutPutData':[]
    },
  };
  public conditionOps=['1','2','3','4','5'];
  public actionItemOps=//['CR','PR','PR-90','OR','RR'];
  [{name: 'CR', code: 'CR'},
    {name: 'PR', code: 'PR'},
    {name: 'PR-90', code: 'PR-90'},
    //{name: 'OR', code: 'OR'},
    {name: 'RR', code: 'RR'}
  ];
  public frmHtmlCat=["PropertyAsReportedHTML","PropertyConditionAssessmentHTML","PropertyConditionAssessmentPropertyCoreCharacteristicsHTML"];
  public frmHtmlSubCat={
    "PropertyAsReportedHTML":["FrmLoanNo","PostalCode","StateUspsCode","CityName","AccountName","PartyBusinessAccountId","AddressLineText","AsReportedName"],
    "PropertyConditionAssessmentHTML":["FirmCityName","FinalAsmntDate","FirmStateUspsCode","FirmPostalCode","InspectorTitle","OnsiteContactName","InspectorPhoneNumber","FirmName","InspectorName","FirmAddressLineText","OnsiteContactPhoneNumber","PrelimInspectionDate","AtInpectionWeatherDescription"],
    "PropertyConditionAssessmentPropertyCoreCharacteristicsHTML":["PptyBuildingAgeYrCount","PptyFloorCount", "PptyNonRsdntlBuildingCount","PptyRsdntlBuildingCount"]
  }
  public frmUnit=['ALLOW','CR','EA','LB','LF','MD','SF','SY','UNIT','YD'];
  public frmCategory=[{'label':'Immediate Repaire Category', 'id':'fme_exec_sum_ir'},{'label':'Captical Item categroy ', 'id':'fme_exec_sum_capital_needs'}];
  public immiCategory=[{'label':'Life Safty Repairs', 'id':'fme_exec_sum_ir_1', 'tag':'LifeSafetyRepairs','othertag':'OtherImmediateRepairsLS','othersubtag':'OIRLS', 'othergdtag':'OIRLSGroupDescription'},
  {'label':'Critical Repairs', 'id':'fme_exec_sum_ir_2', 'tag':'CriticalRepairs','othertag':'OtherImmediateRepairsCR','othersubtag':'OIRCR', 'othergdtag':'OIRCRGroupDescription'},
  {'label':'Deferred Maintenance', 'id':'fme_exec_sum_ir_3', 'tag':'DeferredMaintenance','othertag':'OtherImmediateRepairsDM','othersubtag':'OIRDM', 'othergdtag':'OIRDMGroupDescription'},
  {'label':'Items Of Note', 'id':'fme_exec_sum_ir_5', 'tag':'ItemsOfNote','othertag':'OtherImmediateRepairsIN','othersubtag':'OIRIN', 'othergdtag':'OIRINGroupDescription'},
  {'label':'Short Term Replacement Of Capital Items', 'id':'fme_exec_sum_ir_4', 'tag':'ShortTermReplacementOfCapitalItems','othertag':'OtherImmediateRepairsST','othersubtag':'OIRST', 'othergdtag':'OIRSTGroupDescription'}];
  public capitalTitleRow=
    [{'COLUMNINTERNALNAME': 'col0', 'data': '', 'KEY': 'Item', 'bk':'fme-bluecell', 'weight':'normal', 'border':'1px solid black'},
    {'COLUMNINTERNALNAME': 'col1', 'data': '', 'KEY': '', 'bk':'fme-bluecell', 'weight':'normal', 'border':'1px solid black', 'colspan':9},
    ]  
  public capitalCategory=[
    {'label':'Site', 'id':'fme_exec_sum_capital_needs_1','tag':'site'},
    {'label':'Structural, building envelope and common area furniture, fixtures and equipment','tag':'sffe', 'id':'fme_exec_sum_capital_needs_2'},
    {'label':'Mechanical and electrical','tag':'mechanicalAndElectrical', 'id':'fme_exec_sum_capital_needs_3'},
    {'label':'Dwelling units', 'tag':'dwellingUnits', 'id':'fme_exec_sum_capital_needs_4'},
  ];
 public frmsection= {'required':true, 'TYPE':'1105', "id":"frm_sec", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':'Freddie Mac','SUB_SECTIONS':[], 'NEW':true, 'frmData':null, 'OSNAME':true};
		
  public sectionSet=[
    {'required':true, 'HIDEFRM':true, 'TYPE':'1105', "id":"frm_sec0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':'Section I: Summary','SUB_SECTIONS':[], 'NEW':true},
		{'required':true, 'HIDEFRM':true, 'TYPE':'1105', "id":"frm_sec1", 'DISPLAY_SEQUENCE':"N", 'SECTION_SEQUENCE':"", 'SECTION_TITLE':'Section II: Property Inspection and Evaluation','SUB_SECTIONS':[], 'NEW':true},
	  {'required':true, 'HIDEFRM':true, 'TYPE':'1105', "id":"frm_sec2", 'DISPLAY_SEQUENCE':"N", 'SECTION_SEQUENCE':"", 'SECTION_TITLE':'Section III: Repairs and Cost Estimates','SUB_SECTIONS':[], 'NEW':true},
		{'required':true, 'HIDEFRM':true, 'TYPE':'1105', "id":"frm_sec3", 'DISPLAY_SEQUENCE':"N", 'SECTION_SEQUENCE':"", 'SECTION_TITLE':'Section IV: Private Wells, Wastewater Treatment Systems and Lift Stations','SUB_SECTIONS':[], 'NEW':true},
		{'required':true, 'HIDEFRM':true, 'TYPE':'1105', "id":"frm_sec4", 'DISPLAY_SEQUENCE':"N", 'SECTION_SEQUENCE':"", 'SECTION_TITLE':'Section V: Manufactured Housing Communities','SUB_SECTIONS':[], 'NEW':true},
		{'required':true, 'HIDEFRM':true, 'TYPE':'1105', "id":"frm_sec5", 'DISPLAY_SEQUENCE':"N", 'SECTION_SEQUENCE':"", 'SECTION_TITLE':'Section VI: Capital Needs Over the Loan Term','SUB_SECTIONS':[], 'NEW':true},
		{'required':true, 'HIDEFRM':true, 'TYPE':'1105', "id":"frm_sec6", 'DISPLAY_SEQUENCE':"N", 'SECTION_SEQUENCE':"", 'SECTION_TITLE':'Section VII: Repair Categories','SUB_SECTIONS':[], 'NEW':true},   
  ]

  public subSectionSet={
    'frm_sec0':[
      {'required':true, 'TYPE':'1105', "id":"frm_sec0_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':'Mortgage, Consultant and Property Information ','SUB_SECTIONS':[], 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec0_1", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':'Building and Material Characteristics','SUB_SECTIONS':[], 'dataset':'PropertySeismicRiskAssessment.PropertyConditionAssessmentBuildingAndMaterials', 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec0_2", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':'Unit Mix','SUB_SECTIONS':[],'dataset':'PropertyCommercialUsageMix,PropertyResidentialUnitMix,PropertyResidentialRentalUnit', 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec0_3", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':'Unit Inspection Information','SUB_SECTIONS':[],'dataset':'', 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec0_4", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"List of Parties Present",'SUB_SECTIONS':[], 'dataset':'', 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec0_5", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':'Seismic Checklist','SUB_SECTIONS':[],'dataset':'', 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec0_6", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Consultant's Certification",'SUB_SECTIONS':[], 'dataset':'', 'frmJson':null},

    ], 
    'frm_sec1':[
      {'required':true, 'TYPE':'1105', "id":"frm_sec1_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"",'SUB_SECTIONS':[], 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec1_1", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Site",'SUB_SECTIONS':[
        {'required':true, 'TYPE':'1105-table', "id":"frm_sec1_1_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"", 'frmJson':null}
      ]},
      {'required':true, 'TYPE':'1105', "id":"frm_sec1_2", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Structural, building envelope and common area furniture, fixtures and equipment",'SUB_SECTIONS':[
        {'required':true, 'TYPE':'1105-table', "id":"frm_sec1_2_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"", 'frmJson':null}
      ]},
      {'required':true, 'TYPE':'1105', "id":"frm_sec1_3", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Mechanical and electrical",'SUB_SECTIONS':[
        {'required':true, 'TYPE':'1105-table', "id":"frm_sec1_3_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"", 'frmJson':null}
      ]},
      {'required':true, 'TYPE':'1105', "id":"frm_sec1_4", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Dwelling units",'SUB_SECTIONS':[
        {'required':true, 'TYPE':'1105-table', "id":"frm_sec1_4_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"", 'frmJson':null}
      ]},

    ],
    'frm_sec2':[
      {'required':true, 'TYPE':'1105', "id":"frm_sec2_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"",'SUB_SECTIONS':[], 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec2_1", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Pricate Wells, Waste Water and Lift Stations",'SUB_SECTIONS':[], 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec2_2", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Critical and Priority Repairs",'SUB_SECTIONS':[], 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec2_3", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Operational Repairs",'SUB_SECTIONS':[], 'frmJson':null},
    ],
 'frm_sec3':[
      {'required':true, 'TYPE':'1105', "id":"frm_sec3_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"",'SUB_SECTIONS':[], 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec3_1", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Repairs Indentification",'SUB_SECTIONS':[], 'frmJson':null},
    ],
    'frm_sec4':[
      {'required':true, 'TYPE':'1105', "id":"frm_sec4_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"",'SUB_SECTIONS':[], 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec4_1", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Manufactured Housing Communities",'SUB_SECTIONS':[], 'frmJson':null},

    ],
    'frm_sec5':[
      {'required':true, 'TYPE':'1105', "id":"frm_sec5_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"",'SUB_SECTIONS':[], 'frmJson':null},
      {'required':true, 'TYPE':'1105', "id":"frm_sec5_1", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"",'SUB_SECTIONS':[
        {'required':true, 'TYPE':'1105-table', "id":"frm_sec5_1_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"SITE", 'frmJson':null},
        {'required':true, 'TYPE':'1105-table', "id":"frm_sec5_1_1", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"STRUCTURAL, BUILDING ENVELOPE AND COMMON AREA FURNITURE, FIXTURES AND EQUIPMENT", 'frmJson':null},
        {'required':true, 'TYPE':'1105-table', "id":"frm_sec5_1_2", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"MECHANICAL AND ELECTRICAL", 'frmJson':null},
        {'required':true, 'TYPE':'1105-table', "id":"frm_sec5_1_3", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"DWELLING UNITS", 'frmJson':null},
        //{'required':true, 'TYPE':'1105-table', "id":"frm_sec5_1_4", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"TOTALS"},
      ]},
     /* {'required':true, 'TYPE':'1105', "id":"frm_sec5_2", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"SITE",'SUB_SECTIONS':[]},
      {'required':true, 'TYPE':'1105', "id":"frm_sec5_3", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"STRUCTURAL, BUILDING ENVELOPE AND COMMON AREA FURNITURE, FIXTURES AND EQUIPMENT",'SUB_SECTIONS':[]},
      {'required':true, 'TYPE':'1105', "id":"frm_sec5_4", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"MECHANICAL AND ELECTRICAL",'SUB_SECTIONS':[]},
      {'required':true, 'TYPE':'1105', "id":"frm_sec5_5", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"DWELLING UNITS",'SUB_SECTIONS':[]},*/

    ],
    'frm_sec6':[
      {'required':true, 'TYPE':'1105', "id":"frm_sec6_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':"Repair Categories",'SUB_SECTIONS':[], 'frmJson':null},
    ],
  }
   
  public childrenSet={
    'frm_sec0_2':[
      {'required':true, 'TYPE':'1105', "id":"frm_sec0_2_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""},
      {'required':true, 'TYPE':'1105', "id":"frm_sec0_2_1", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""}
    ],
    'frm_sec1_1':[{'required':true, 'TYPE':'1105', "id":"frm_sec1_1_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""}],
    'frm_sec1_2':[{'required':true, 'TYPE':'1105', "id":"frm_sec1_2_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""}],
    'frm_sec1_3':[{'required':true, 'TYPE':'1105', "id":"frm_sec1_3_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""}],
    'frm_sec1_4':[{'required':true, 'TYPE':'1105', "id":"frm_sec1_4_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""}],
    'frm_sec5_2':[{'required':true, 'TYPE':'1105', "id":"frm_sec5_2_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""}],
    'frm_sec5_3':[{'required':true, 'TYPE':'1105', "id":"frm_sec5_3_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""}],
    'frm_sec5_4':[{'required':true, 'TYPE':'1105', "id":"frm_sec5_4_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""}],
    'frm_sec5_5':[
      {'required':true, 'TYPE':'1105', "id":"frm_sec5_5_0", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""},
      {'required':true, 'TYPE':'1105', "id":"frm_sec5_5_1", 'DISPLAY_SEQUENCE':"N", "SECTION_SEQUENCE":"", 'SECTION_TITLE':""}
    ],
  }
  public dataCat=[[{'label':'Carports'},
    {'label':'Garages'},
    {'label':'Maintenance structures'},
    {'label':'Trash enclosures'},
    {'label':'Roadways/Parking lots', 'sub':[
      {'label':'Asphaltic concrete'},
      {'label':'Seal coat'},
      {'label':'Concrete paving'},
      {'label':'Other paving'},
      {'label':'Striping'},
      {'label':'Curb and gutter'},
      {'label':'Interior gutter (swale)'},
    ]},
    {'label':'Pedestrian paving/hardscape'},
    {'label':'Signage'},
    {'label':'Site utilities', 'sub':[
      {'label':'Site water lines'},
      {'label':'Site sanitary lines'},
      {'label':'Site lighting'},
      {'label':'Site drainage (storm drainage)'},
    ]},
    {'label':'Landscaping'},
    {'label':'Irrigation'},
    {'label':'Site fences'},
    {'label':'Tennis courts'},
    {'label':'Swimming pool and/or spa', 'sub':[
      {'label':'Pool and/or spa plaster/lining'},
      {'label':'Pool and/or spa heating equipment'},
      {'label':'Pool and/or spa filtration equipment'},
      {'label':'Pool and/or spa deck surface'},
    ]},
    {'label':'Sauna'},
    {'label':'Recreation/Play area and equipment'},
  ],[{'label':'Foundation (structural)'},
	{'label':'Foundation (waterproofing)'},
	{'label':'Building slab (structural)'},
	{'label':'Exterior walls/roof (structural)'},
	{'label':'Exterior walls (paint/finish)'},
	{'label':'Doors and frames'},
	{'label':'Windows and frames'},
	{'label':'Stairs'},
	{'label':'Fire escapes'},
	{'label':'Balconies/Handrails/Guardrails'},
	{'label':'Decks'},
	{'label':'Patio slabs'},
	{'label':'Unit fencing (patio fencing)'},
	{'label':'Roof coverings'},
	{'label':'Roof drainage (gutters, drains, etc.)'},
	{'label':'Building mounted lighting'},
	{'label':'Common area improvements', 'sub':[
		{'label':'Common area floors'},
		{'label':'Community facilities kitchen'},
		{'label':'Community facilities appliances'},
		{'label':'Community washing machines'},
		{'label':'Community clothes dryers'},
	]},
],[{'label':'Mechanical/Plumbing', 'sub':[
  {'label':'Hot and cold water distribution'},
  {'label':'Domestic water boilers'},
  {'label':'Domestic water boiler peripherals'},
  {'label':'Domestic water heaters'},
  {'label':'Domestic water pumps'},
  {'label':'Sanitary waste and vent (sewer)'},
]},
{'label':'Mechanical HVAC', 'sub':[
  {'label':'Heating system    (describe)'},
  {'label':'Cooling system    (describe)'},
]},
{'label':'Electrical', 'sub':[
  {'label':'Building power/wiring'},
  {'label':'Switchgear/metering'},
  {'label':'Emergency lighting/generator'},
  {'label':'Smoke and fire detection'},
  {'label':'Buzzer/intercom (security)'},
]},
{'label':'Fire suppression'},
{'label':'Elevators'},
{'label':'Security'},
],
[{'label':'Unit entry door(s) and frame(s)'},
	{'label':'Patio doors'},
	{'label':'Smoke/fire detection'},
	{'label':'Buzzer/intercom (security)'},
	{'label':'Window coverings'},
	{'label':'Flooring', 'sub':[
		{'label':'Carpet'},
		{'label':'Resilient flooring (vinyl)'},
		//{'label':'Other'},		
	]},
	{'label':'Cabinetry', 'sub':[
		{'label':'Kitchen'},
		{'label':'Bathrooms'},
		//{'label':'Other'},
	]},
	{'label':'Countertops and sinks', 'sub':[
		{'label':'Kitchen'},
		{'label':'Bathrooms'},
		//{'label':'Other'},
	]},
	{'label':'Appliances', 'sub':[
		{'label':'Refrigerator'},
		{'label':'Range/stove'},
		{'label':'Range vent'},
		{'label':'Dishwasher'},
		{'label':'Disposal'},
		{'label':'Microwave'},
		{'label':'Clothes washer'},
		{'label':'Clothes dryer'},		
	]},
	{'label':'Bathroom fixtures', 'sub':[
		{'label':'Toilet'},
		{'label':'Tub/shower and enclosures'},
		{'label':'Accessories'},
	]},
	],
]

 
public frmData={
  "SchemaVersionId": "1.0.0",
  "PropertyAmenity": [],
  "PropertyAsReported": [
  {
  "PostalCode": "",
  "StateUspsCode": "",
  "CityName": "",
  "AccountName": "0",
  "PartyBusinessAccountId": "0",
  "AddressLineText": "",
  "AsReportedName": ""
  }
  ],
  "PropertyConditionAssessmentPropertyCoreCharacteristics": [
    {
    "PptyBuildingAgeYrCount": 0,
    "PptyFloorCount": 0,
    "PptyNonRsdntlBuildingCount": 0,
    "PptyRsdntlBuildingCount": 0
    }
  ],
  "PropertyConditionAssessment": [
  {
  "CapitalExpenditureMrtgTermYrCount": 0,
  "CapitalExpenditureTotalLoanTermUninflatedAmt": 0,
  "CapitalExpenditureTotalLoanTermInflatedAmt": 0,
  "CapitalExpenditureUnitAnnualUninflatedAmt": 0,
  "CapitalExpenditureUnitAnnualInflatedAmt": 0,
  "FirmName": "",
  "FirmPostalCode": "",
  "FirmCityName": "",
  "FirmStateUspsCode": "",
  "FirmAddressLineText": "",
  "InspectorPhoneNumber": "",
  "InspectorTitle": "",
  "InspectorName": "",
  "ManufacturedHousingInd": "N",
  "OnsiteContactName": "",
  "AtInpectionWeatherDescription": "",
  "OnsiteContactPhoneNumber": "",
  "FinalAsmntDate": "1900-01-00T00:00:00.000Z",
  "PrelimInspectionDate": "1900-01-00T00:00:00.000Z",
  "RsdntlDownInspectedUnitCount": 0,
  "RsdntlOccupiedInspectedUnitCount": 0,
  "RsdntlOtherInspectedUnitCount": 0,
  "RsdntlVacantInspectedUnitCount": 0,
  "ManufacturedHousingUtility": [],
  "PropertyCapitalExpenditureProjection": [],  
  "PropertyConditionAssessmentBuildingAndMaterials": [],
  "PropertyConditionAssessmentItem": [],
  "PropertyConditionAssessmentWaterTreatment": [],
  "PropertyConditionAssessmentManufacturedHousing": [],
  "PropertyRepair": [],
  "PropertySeismicRiskAssessment": [
    {
      /*"SeismicRiskFactorInd": "N",
      "BuildingsWithWeakOrSoftFloorsInd": "N",
      "BuildingsWithPrevEarthquakeDamageInd": "N",
      "BuildingsWithReinforcedConcreteBuiltPriorTo1994Indictor": "N",
      "BuildingsWithUnreinforcedMasonryRetrofittedInd": "N",
      "BuildingsWithWoodFrameConspicuousDeteriorationInd": "N",
      "BuildingsWithWoodFrameParkingUnderUnitsNonRetrofittedAndBuiltPriorTo2000Ind": "N",
      "BuildingsLocatedNearFaultOrSpecialStudyZoneInd": "N",*/
      "SeismicRiskFactorInd": "N",
      "BuildingsWithWeakOrSoftFloorsInd": "",
      "BuildingsWithDirectContactToAdjacentBuildingsInd": "",
      "BuildingsWithPrevEarthquakeDamageInd": "",
      "BuildingsHighRiseInd": "",
      "BuildingsWithReinforcedConcreteBuiltPriorTo1994Indictor": "",
      "BuildingsWithReinforcedConcreteLoadBearingWallsBuiltPriorTo1994Ind": "",
      "BuildingsWithUnreinforcedMasonryRetrofittedInd": "",
      "BuildingsWithUnreinforcedMasonryRetrofittedPriorTo1995Indictor": "",
      "BuildingsWithWoodFrameConspicuousDeteriorationInd": "",
      "WoodFrameBuiltPriorTo1950Ind": "",
      "BuildingsWithWoodFrameParkingUnderUnitsNonRetrofittedAndBuiltPriorTo2000Ind": "",
      "BuildingsWithLightFrameOverConcretePodiumBuiltPriorTo1994Ind": "",
      "BuildingsLocatedNearFaultOrSpecialStudyZoneInd": ""
      }
  ]
  }
  ],
  "PropertyTotalRentRollSummary": [							
    {
    "PptyTotalOtherMgmtOfficeUnitCount": 0,
    "PptyTotalOtherModelUnitCount": 0,
    "PptyTotalOtherMaintenanceShopUnitCount": 0,
    "PptyTotalOtherStorageUnitCount": 0,
    "PptyTotalOtherHospitalitySuiteUnitCount": 0,
    "PptyTotalOtherMiscellaneousUnitCount": 0,
    "TotalOtherUnitCount": 0,
    "PptyTotalDownUnitCount": 0,
    "TotalOccupiedUnitCount": 0,
    "TotalVacantUnitCount": 0,
    "TotalUnitCount": 0,
    "PropertyCommercialRentRollSummary": [
      {"CommercialTotalUnitCount": 0}
    ],
    "PropertyResidentialRentRollSummary": [
      {
        "RsdntlTotalUnitCount": 0
        }
    ],
    
    "PropertyCommercialUsageMix": [
      {
        "UsageType": "p",
        "OccupiedUnitCount": 0,
        "VacantUnitCount": 0,
        "DownUnitCount": 0,
        "UnitCount": 0
        },
        {
        "UsageType": "c",
        "OccupiedUnitCount": 0,
        "VacantUnitCount": 0,
        "DownUnitCount": 0,
        "UnitCount": 0
        }
    ],
    "PropertyResidentialUnitMix": [],
    "PropertyResidentialRentalUnit": []
    }
    ],
    "PropertyAsReportedHTML": 
  {
   "FrmLoanNo": {'html':'<p><span class="placeholder" data-id="75" data-type="text" data-status="N">{Freddie Mac Loan Number}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "PostalCode": {'html':'<p><span class="placeholder" data-id="12" data-type="text" data-status="N">{Property Zipcode/Postal Code}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "StateUspsCode": {'html':'<p><span class="placeholder" data-id="11" data-type="text" data-status="N">{Property State/Province}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "CityName": {'html':'<p><span class="placeholder" data-id="10" data-type="text" data-status="N">{Property City}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "AccountName": {'html':'<p><span class="placeholder" data-id="73" data-type="text" data-status="N">{Seller/Servicer Name}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "PartyBusinessAccountId": {'html':'<p><span class="placeholder" data-id="74" data-type="text" data-status="N">{Seller/Servicer Number}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "AddressLineText": {'html':'<p><span class="placeholder" data-id="8" data-type="text" data-status="N">{Property Address}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "AsReportedName": {'html':'<p><span class="placeholder" data-id="7" data-type="text" data-status="N">{Property Name}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    /* "FrmLoanNo": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "PostalCode": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "StateUspsCode": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "CityName": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "AccountName": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "PartyBusinessAccountId": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "AddressLineText": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "AsReportedName": {'html':'','data':'', 'secHtml':null, 'addedItem':null},*/
  },
  "PropertyConditionAssessmentHTML": 
  {
   "FirmName": {'html':'<p><span class="placeholder" data-id="108" data-type="text" data-status="N">{Company Name (Consultant)}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "FirmPostalCode": {'html':'<p><span class="placeholder" data-id="113" data-type="text" data-status="N">{Company Zipcode/Postcode}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "FirmCityName": {'html':'<p><span class="placeholder" data-id="111" data-type="text" data-status="N">{Company City}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "FirmStateUspsCode": {'html':'<p><span class="placeholder" data-id="112" data-type="text" data-status="N">{Company State/Province}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "FirmAddressLineText": {'html':'<p><span class="placeholder" data-id="109" data-type="text" data-status="N">{Company Street Address}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "InspectorPhoneNumber": {'html':'<p><span class="placeholder" data-id="116" data-type="text" data-status="N">{Company Contact Telephone #}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "InspectorTitle": {'html':'<p><span class="placeholder" data-id="82" data-type="text" data-status="N">{Writer Title}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "InspectorName": {'html':'<p><span class="placeholder" data-id="79" data-type="text" data-status="N">{Writer Name}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "OnsiteContactName": {'html':'<p><span class="placeholder" data-id="49" data-type="text" data-status="N">{Site Contact Name}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "AtInpectionWeatherDescription": {'html':'<p><span class="placeholder" data-id="1026" data-type="text" data-status="N">{Weather Condition}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "OnsiteContactPhoneNumber": {'html':'<p><span class="placeholder" data-id="51" data-type="text" data-status="N">{Site Contact Telephone # }</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "FinalAsmntDate": '',
    "PrelimInspectionDate": '',
     /*"FirmName": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "FirmPostalCode": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "FirmCityName": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "FirmAddressLineText": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "InspectorPhoneNumber": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "InspectorTitle": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "InspectorName": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "OnsiteContactName": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "AtInpectionWeatherDescription": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "OnsiteContactPhoneNumber": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "FinalAsmntDate": {'html':'','data':'', 'secHtml':null, 'addedItem':null},
    "PrelimInspectionDate": {'html':'','data':'', 'secHtml':null, 'addedItem':null},*/
  },
  "PropertyConditionAssessmentPropertyCoreCharacteristicsHTML": 
  {
    "PptyBuildingAgeYrCount": {'html':'<p><span class="placeholder" data-id="43" data-type="text" data-status="N">{Building Age}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "PptyFloorCount": {'html':'<p><span class="placeholder" data-id="28" data-type="text" data-status="N">{Number of Stories}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "PptyNonRsdntlBuildingCount": {'html':'<p><span class="placeholder" data-id="192" data-type="text" data-status="N">{Number of Other Structures}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "PptyRsdntlBuildingCount": {'html':'<p><span class="placeholder" data-id="22" data-type="text" data-status="N">{Number of Buildings}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
    "TotalUnitCount": {'html':'<p><span class="placeholder" data-id="34" data-type="text" data-status="N">{Number of Units}</span></p>','data':'', 'secHtml':null, 'addedItem':null},
  },
  "ListOfParties":[
    {
      "Name":"",
      "Title":"",
      "Company":"",
      "Affiliation":"",
      "Comments":"",
    },
    /*{
      "Name":"",
      "Title":"",
      "Company":"",
      "Affiliation":"",
      "Comments":"",
    },*/
  ],
  'sec4OutPutData':[0, '$0'],
  "waterCheck":[false, false, false, false, false],
  'overallPropertyRating':{'overallCondition':'','overallRating':''},
  }

  public tableSet={'sec2tables':{
    'cols':[
      {'INTERNALNAME':"col1",'KEY':"Item",'NAME':"Item",'TYPE':"text",'celAllign':"Left",'colAlign':"Left",'dir':"default",'unit':"%",'width':25, 'bk':'none', 'border':'1px solid black'},
      {'INTERNALNAME':"col2",'KEY':"EUL",'NAME':"Estimated Useful Life",'TYPE':"text",'celAllign':"Center",'colAlign':"Left",'dir':"default",'unit':"%",'width':13, 'bk':'none', 'border':'1px solid black'},
      {'INTERNALNAME':"col3",'KEY':"CONDITION",'NAME':"Condition (1, 2, 3, 4, 5)",'TYPE':"text",'celAllign':"Center",'colAlign':"Left",'dir':"default",'unit':"%",'width':13, 'bk':'none', 'border':'1px solid black'},
      {'INTERNALNAME':"col4",'KEY':"RUL",'NAME':"Remaining Useful Life",'TYPE':"text",'celAllign':"Center",'colAlign':"Left",'dir':"default",'unit':"%",'width':13, 'bk':'none', 'border':'1px solid black'},
      {'INTERNALNAME':"col5",'KEY':"ACTION",'NAME':"Action (CR, PR, PR-90, RR)",'TYPE':"text",'celAllign':"Center",'colAlign':"Left",'dir':"default",'unit':"%",'width':13, 'bk':'none', 'border':'1px solid black'},
      {'INTERNALNAME':"col6",'KEY':"",'NAME':"Comments/Mold Observations",'TYPE':"text",'celAllign':"Left",'colAlign':"Center",'dir':"default",'unit':"%",'width':23, 'bk':'none', 'border':'1px solid black'}
      ],
    'baserow':[
        {'COLUMNINTERNALNAME': 'col0', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
        {'COLUMNINTERNALNAME': 'col1', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
        {'COLUMNINTERNALNAME': 'col2', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
        {'COLUMNINTERNALNAME': 'col3', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black','cal1':true},
        {'COLUMNINTERNALNAME': 'col4', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black', 'ops':['CR', 'PR', 'PR-90', 'RR']},
        {'COLUMNINTERNALNAME': 'col5', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},             
      ],
    'rowItem':[[{'key':'Carports', 'sub':[]},
        {'key':'Garages', 'sub':[]},
        {'key':'Maintenance structures', 'sub':[]},
        {'key':'Trash enclosures', 'sub':[]},
        {'key':'Roadways/Parking lots', 'sub':['Asphaltic concrete','Seal coat','Concrete paving','Other paving','Striping','Curb and gutter','Interior gutter (swale)']},
        {'key':'Pedestrian paving/hardscape', 'sub':[]},
        {'key':'Signage', 'sub':[]},
        {'key':'Site utilities', 'sub':['Site water lines','Site sanitary lines','Site lighting','Site drainage (storm drainage)']},
        {'key':'Landscaping', 'sub':[]},
        {'key':'Irrigation', 'sub':[]},
        {'key':'Site fences', 'sub':[]},
        {'key':'Tennis courts', 'sub':[]},
        {'key':'Swimming pool and/or spa', 'sub':['Pool and/or spa plaster/lining','Pool and/or spa heating equipment','Pool and/or spa filtration equipment','Pool and/or spa deck surface']},
        {'key':'Sauna', 'sub':[]},
        {'key':'Recreation/Play area and equipment', 'sub':[]},        
      ],
      [{'key':'Foundation (structural)'},
      {'key':'Foundation (waterproofing)'},
      {'key':'Building slab (structural)'},
      {'key':'Exterior walls/roof (structural)'},
      {'key':'Exterior walls (paint/finish)'},
      {'key':'Doors and frames'},
      {'key':'Windows and frames'},
      {'key':'Stairs'},
      {'key':'Fire escapes'},
      {'key':'Balconies/Handrails/Guardrails'},
      {'key':'Decks'},
      {'key':'Patio slabs'},
      {'key':'Unit fencing (patio fencing)'},
      {'key':'Roof coverings'},
      {'key':'Roof drainage (gutters, drains, etc.)'},
      {'key':'Building mounted lighting'},
      {'key':'Common area improvements', 'sub':['Common area floors','Community facilities kitchen','Community facilities appliances','Community washing machines','Community clothes dryers']},
    ],
    [
      {'key':'Mechanical/Plumbing', 'sub':['Hot and cold water distribution','Domestic water boilers','Domestic water boiler peripherals','Domestic water heaters','Domestic water pumps','Sanitary waste and vent (sewer)']},
      {'key':'Mechanical HVAC', 'sub':['Heating system (describe)','Cooling system (describe)']},
      {'key':'Electrical', 'sub':['Building power/wiring','Switchgear/metering','Emergency lighting/generator','Smoke and fire detection','Buzzer/intercom (security)']},
      {'key':'Fire suppression'},
      {'key':'Elevators'},
      {'key':'Security'},
    ],
    [
      {'key':'Unit entry door(s) and frame(s)'},
      {'key':'Patio doors'},
      {'key':'Smoke/fire detection'},
      {'key':'Buzzer/intercom (security)'},
      {'key':'Window coverings'},
      {'key':'Flooring', 'sub':['Carpet','Resilient flooring (vinyl)']},
      {'key':'Cabinetry', 'sub':['Kitchen','Bathrooms']},
      {'key':'Countertops and sinks', 'sub':['Kitchen','Bathrooms']},
      {'key':'Appliances', 'sub':['Refrigerator','Range/stove','Range vent','Dishwasher','Disposal','Microwave','Clothes washer','Clothes dryer']},
      {'key':'Bathroom fixtures', 'sub':['Toilet','Tub/shower and enclosures','Accessories']},
    ],
  ],
  'CatType':['site','sffe','mechanicalAndElectrical','dwellingUnits']
},
  'sec3tables':{
    'cols':[
      {'INTERNALNAME':"col1",'KEY':"Item",'NAME':"Item",'TYPE':"text",'celAllign':"Left",'colAlign':"Left",'dir':"default",'unit':"%",'width':25, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col2",'KEY':"",'NAME':"Repair Type",'TYPE':"text",'celAllign':"Center",'colAlign':"Left",'dir':"default",'unit':"%",'width':10, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col3",'KEY':"",'NAME':"Unit of Measure",'TYPE':"text",'celAllign':"Center",'colAlign':"Left",'dir':"default",'unit':"%",'width':8, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col4",'KEY':"",'NAME':"Quantity",'TYPE':"text",'celAllign':"Center",'colAlign':"Left",'dir':"default",'unit':"%",'width':8, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col5",'KEY':"",'NAME':"Per Item Cost",'TYPE':"text",'celAllign':"Center",'colAlign':"Left",'dir':"default",'unit':"%",'width':12, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col5",'KEY':"",'NAME':"Total Costs",'TYPE':"text",'celAllign':"Center",'colAlign':"Left",'dir':"default",'unit':"%",'width':12, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col6",'KEY':"",'NAME':"Comments",'TYPE':"text",'celAllign':"Left",'colAlign':"Left",'dir':"default",'unit':"%",'width':25, 'bk':'frm-graycell', 'border':'1px solid black'}
      ],
    'baserow':[
        {'COLUMNINTERNALNAME': 'col0', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
        {'COLUMNINTERNALNAME': 'col1', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
        {'COLUMNINTERNALNAME': 'col2', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
        {'COLUMNINTERNALNAME': 'col3', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
        {'COLUMNINTERNALNAME': 'col4', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black', 'sign':'$'},
        {'COLUMNINTERNALNAME': 'col5', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black', 'sign':'$'},
        {'COLUMNINTERNALNAME': 'col6', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
    ],
    'totalrow':[
      {'COLUMNINTERNALNAME': 'col0', 'data': 'Subtotal', 'KEY': '', 'bk':'frm-graycell', 'weight':'bold', 'border':'1px solid black','colspan':5, 'celAllign':"right"},
      {'COLUMNINTERNALNAME': 'col1', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black', 'sign':'$'},
      {'COLUMNINTERNALNAME': 'col2', 'data': '', 'KEY': '', 'bk':'frm-graycell', 'weight':'normal', 'border':'1px solid black'},

    ]
  },
  'sec6tables':{
    'cols':[
      {'INTERNALNAME':"col1",'KEY':"Item",'NAME':"Item",'TYPE':"text",'celAllign':"Left",'colAlign':"Left",'dir':"default",'unit':"%",'width':18, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col2",'KEY':"EUL",'NAME':"Quantity",'TYPE':"text",'celAllign':"Center",'colAlign':"Center",'dir':"default",'unit':"%",'width':6, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col3",'KEY':"EFF",'NAME':"Unit of Measure",'TYPE':"text",'celAllign':"Center",'colAlign':"Center",'dir':"default",'unit':"%",'width':6, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col4",'KEY':"RUL",'NAME':"Per Item Cost",'TYPE':"text",'celAllign':"Center",'colAlign':"Center",'dir':"default",'unit':"%",'width':7, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col5",'KEY':"ACTION",'NAME':"Year X",'TYPE':"text",'celAllign':"Center",'colAlign':"Center",'dir':"default",'unit':"%",'width':54, 'bk':'frm-graycell', 'border':'1px solid black'},
      {'INTERNALNAME':"col6",'KEY':"",'NAME':"Total",'TYPE':"text",'celAllign':"Center",'colAlign':"Center",'dir':"default",'unit':"%",'width':9, 'bk':'frm-graycell', 'border':'1px solid black'}
      ],
    'baserow':[
        {'COLUMNINTERNALNAME': 'col0', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
        {'COLUMNINTERNALNAME': 'col1', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
        {'COLUMNINTERNALNAME': 'col2', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'},
        {'COLUMNINTERNALNAME': 'col3', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black', 'sign':'$'},
        {'COLUMNINTERNALNAME': 'col4', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black', 'sign':'$'},
        {'COLUMNINTERNALNAME': 'col5', 'data': '', 'KEY': '', 'bk':'frm-graycell', 'weight':'normal', 'border':'1px solid black', 'sign':'$'},             
      ],
    'rowItem':[[{'key':'Carports', 'sub':[]},
        {'key':'Garages', 'sub':[]},
        {'key':'Maintenance structures', 'sub':[]},
        {'key':'Trash enclosures', 'sub':[]},
        {'key':'Roadways/Parking lots', 'sub':['Asphaltic concrete','Seal coat','Concrete paving','Other paving','Striping','Curb and gutter','Interior gutter (swale)']},
        {'key':'Pedestrian paving/hardscape', 'sub':[]},
        {'key':'Signage', 'sub':[]},
        {'key':'Site utilities', 'sub':['Site water lines','Site sanitary lines','Site lighting','Site drainage (storm drainage)']},
        {'key':'Landscaping', 'sub':[]},
        {'key':'Irrigation', 'sub':[]},
        {'key':'Site fences', 'sub':[]},
        {'key':'Tennis courts', 'sub':[]},
        {'key':'Swimming pool and/or spa', 'sub':['Pool and/or spa plaster/lining','Pool and/or spa heating equipment','Pool and/or spa filtration equipment','Pool and/or spa deck surface']},
        {'key':'Sauna', 'sub':[]},
        {'key':'Recreation/Play area and equipment', 'sub':[]},        
      ],
    [
      {'key':'Foundation (structural)'},
      {'key':'Foundation (waterproofing)'},
      {'key':'Building slab (structural)'},
      {'key':'Exterior walls/roof (structural)'},
      {'key':'Exterior walls (paint/finish)'},
      {'key':'Doors and frames'},
      {'key':'Windows and frames'},
      {'key':'Stairs'},
      {'key':'Fire escapes'},
      {'key':'Balconies/Handrails/Guardrails'},
      {'key':'Decks'},
      {'key':'Patio slabs'},
      {'key':'Unit fencing (patio fencing)'},
      {'key':'Roof coverings'},
      {'key':'Roof drainage (gutters, drains, etc.)'},
      {'key':'Building mounted lighting'},
      {'key':'Common area improvements', 'sub':['Common area floors','Community facilities kitchen','Community facilities appliances','Community washing machines','Community clothes dryers']},
    ],
    [
      {'key':'Mechanical/Plumbing', 'sub':['Hot and cold water distribution','Domestic water boilers','Domestic water boiler peripherals','Domestic water heaters','Domestic water pumps','Sanitary waste and vent (sewer)']},
      {'key':'Mechanical HVAC', 'sub':['Heating system (describe)','Cooling system (describe)']},
      {'key':'Electrical', 'sub':['Building power/wiring','Switchgear/metering','Emergency lighting/generator','Smoke and fire detection','Buzzer/intercom (security)']},
      {'key':'Fire suppression'},
      {'key':'Elevators'},
      {'key':'Security'},
    ],
    [
      {'key':'Unit entry door(s) and frame(s)'},
      {'key':'Patio doors'},
      {'key':'Smoke/fire detection'},
      {'key':'Buzzer/intercom (security)'},
      {'key':'Window coverings'},
      {'key':'Flooring', 'sub':['Carpet','Resilient flooring (vinyl)']},
      {'key':'Cabinetry', 'sub':['Kitchen','Bathrooms']},
      {'key':'Countertops and sinks', 'sub':['Kitchen','Bathrooms']},
      {'key':'Appliances', 'sub':['Refrigerator','Range/stove','Range vent','Dishwasher','Disposal','Microwave','Clothes washer','Clothes dryer']},
      {'key':'Bathroom fixtures', 'sub':['Toilet','Tub/shower and enclosures','Accessories']},
    ],
  ],

}
}
  public pdfHead="<!DOCTYPE HTML>"+
  "<html>"+  
  "<head>"+
  "<style>"+
  "* {"+
  "padding: 0;"+
  "margin: 0;"+
  "box-sizing: border-box;"+
  "}"+
  
  "html {"+
  "font-size: 10px;"+
  "font-family: Arial, Helvetica, sans-serif;"+
  "}"+
  
  "body {"+
  "margin: 0;"+
  "}"+
  
  '.page-before {'+
 'display: block;'+
  'page-break-before: always;'+
  '}'+
  
  '.page-after {'+
  'display: block;'+
  'page-break-after: always;'+
  '}'+
  
  'h1 {'+
  'margin-bottom: 14px;'+
  'font-size: 14px;'+
  'text-align: right;'+
  'padding-right: 0.5em;'+
  '}'+
  
'h2 {'+
  'margin-top: 4px;'+
  'padding: 1px 0.6rem;'+
  'display: block;'+
  'font-size: 10x;'+
  'background-color: #000;'+
  'color: #fff;'+
  '}'+
  
  'h3 {'+
  'margin: 10px 0;'+
  'font-size: 10px;'+
  'display: block;'+
  'background-color: #000;'+
  'color: #fff;'+
  '}'+
  
 'h4 {'+
  'margin-top: 0.8rem;'+
  'font-size: 10px;'+
  'display: block;'+
  '}'+
  
  'ol,'+
  'ul {'+
  'padding: 0 0 1rem 1.5rem;'+
  '}'+
  
  'table {'+
  'width: 100%;'+
  'border-collapse: collapse;'+
  '}'+
  
  'table thead {'+
  'display: table-header-group;'+
  '}'+
  
  'table thead tr th {'+
  'padding: 8px;'+
  'background-color: #eeeeee;'+
  'font-size: 11px;'+
   'font-weight: 600;'+
   'text-align: center;'+
   'border: 1px solid #000;'+
  'border-collapse: collapse;'+
  'border-collapse: collapse;'+
  '}'+
  
  'table tbody tr td {'+
   'padding: 8px;'+
   'font-size: 11px;'+
   'border: 1px solid #000;'+
   'border-collapse: collapse;'+
  '}'+
  
  '@page landscape {'+
   'size: 11in 8.5in;'+
              '}'+
  
              '@page portrait {'+
              'size: 8.5in 11in;'+
              '}'+
  
              '@page no-header {'+
              'margin-top: 10px !important;'+
              '}'+
  
              '.landscape-content {'+
              'page: landscape;'+
              '}'+
  
               '.portrait-content {'+
              'page: portrait;'+
              '}'+
  
              '.no-header-content {'+
              'page: no-header;'+
              '}'+
  
          /* freddie mac styles */
           '.freddie-mac {'+
          'position: relative;'+
          'padding-top: 20px;'+
          '}'+
  
          '.freddie-mac-header {'+
          'width: 100%;'+
          'display: flex;'+
           'justify-content: space-between;'+
           '}'+
  
          '.freddie-mac-logo {'+
          'width: 55%'+
          '}'+
  
          '.freddie-mac-logo img {'+
          'width: 150px;'+
          'margin-left: 18px;'+
          '}'+
  
          '.freddie-mac-title {'+
          'border-top: solid 8px black;'+
          'font-size: 14px;'+
          'text-align: right;'+
          'padding-right: 1rem;'+
          'width: 45%;'+
          '}'+
          '.freddie-mac-title1 {'+
          'border-top: solid 8px black;'+
          'font-size: 14px;'+
          'text-align: left;'+
          'padding-left: 1rem;'+
          'width: 45%;'+
          '}'+
          'table.section-header {'+
          'border-collapse: separate;'+
          'border-spacing: 0;margin-bottom:10px'+
          '}'+
  
          'table.section-header td {'+
          'border: 0;'+
          'padding: 0;'+
          'vertical-align: bottom;'+
          'font-size: 8.4pt;'+
          '}'+
  
          'table.section-header td div {'+
          'margin: 4px 5px 0 0;'+
          'position: relative;'+
          'border-left: 6px solid black;'+
          'border-bottom: 1.5px solid black;'+
          'padding: 1.4rem 0.8rem 0.05rem 1.2rem;'+
          'min-height:2.7rem;'+
          '}'+
  
          'table.section-header td.fh {'+
          'border-left: 6px solid black;'+
          '}'+
  
          'table.section-header td.fh div {'+
          'border-left: 0;'+
          '}'+
  
          'table.section-header td.fw {'+
          'border-bottom: 2px solid black;'+
          '}'+
  
          'table.section-header td.fw div {'+
          'border-bottom: 0;'+
          '}'+
  
          'table.section-header td label {'+
          'position: absolute;'+
          'top: 0;'+
          'left: 0;'+
          'font-size: 5.4pt;'+
          'padding-left: 2px;'+
          '}'+
          'table.datatable th label{'+
          'width: 50%;'+
          '}'+
          'table.datatable td,table.datatable th,table.datatable tr{'+
          'padding: 0 2px;'+
          'font-size: 7.5pt;'+
          '}'+
          'table.datatable1 td,table.datatable1 th,table.datatable1 tr{'+
          'padding: 0 2px;'+
          'font-size: 6.12pt;'+
          '}'+

          'div.input-box {'+
          'margin: 0.5em 0;'+
          '}'+
  
          'div.textarea {'+
          'border: solid 1px black;'+
          'min-height:16px !important;'+
          'white-space: pre-line;'+
          '}'+
  
          '.input-box textarea {'+
          'display: block;'+
          'width: 100%;'+
          'border: solid 1px black;min-height:16px;'+
          '}'+
  
          '.input-box label {'+
          'margin-left: 1px;'+
          '}'+
  
          '.question-box {'+
          'padding-left: 2rem;'+
          '}'+
  
          '.question-line {'+
          'display: flex;'+
          'justify-content: space-between;'+
          '}'+
  
          '.question:has(.textarea) {'+
          'width: 70%;'+
           '}'+
           '.rateItem{'+
            'margin-top: 10px;'+
            'font-weight: bold;'+
            'font-size: 14px;'+
          '}'+
          '.reason-box{border-left: #000 6px solid;'+
           'border-bottom: #000 1px solid;'+
           'margin:2px 0'+
          '}'+
          '.reason-box label{font-size: 5.4pt;'+
           'padding-left: 2px;'+
          '}'+
          '.numberCell{border:none;'+
           'width:3%;'+
          '}'+
          '.underlineCell{border:none;'+
           'border-bottom: #000 1px solid;'+
          '}'+
          'td.wrapper {'+
          'border: 0;'+
          'padding: 0;'+
          '}'+
          '.frmBtn{'+
            'background-color: #000000;'+
            'color: white;'+
            'width:120px'+
            "padding:4px 0"+
          '}'+
          '.checkbox-unchecked {'+
          'display: inline-block;'+
          'background-image: url("https://erisservice9.erisinfo.com/exreportw/frmimages/checkbox-unchecked.jpg");'+
          'background-repeat: no-repeat;'+
          'background-size: 12px 12px;'+
          'padding: 1px 0 0 16px;'+
          '}'+
  
          '.checkbox-checked {'+
          'display: inline-block;'+
          'background-image: url("https://erisservice9.erisinfo.com/exreportw/frmimages/checkbox-checked.jpg");'+
          'background-repeat: no-repeat;'+
          'background-size: 12px 12px;'+
          'padding: 1px 0 0 16px;'+
          '}'+
          '.checkbox-unchecked1 {'+
          'display: inline-block;'+
          'background-image: url("https://erisservice9.erisinfo.com/exreportw/frmimages/checkbox-unchecked-shadow.jpg");'+
          'background-repeat: no-repeat;'+
          'background-size: 12px 12px;'+
          'padding: 1px 0 0 16px;'+
          '}'+
  
          '.checkbox-checked1 {'+
          'display: inline-block;'+
          'background-image: url("https://erisservice9.erisinfo.com/exreportw/frmimages/checkbox-checked-shadow.jpg");'+
          'background-repeat: no-repeat;'+
          'background-size: 12px 12px;'+
          'padding: 1px 0 0 16px;'+
          '}'+
          '.checkbox-nobox {'+
          'padding: 1px 0 0 16px;'+
          '}'+
          '.checkbox-other {'+
           ' display: flex;'+
           'flex-wrap: wrap;'+
       ' }'+
        '.checkbox-other .under-line {'+
            'display: block;'+
            'flex: 1;'+
           ' white-space: nowrap;'+
           ' overflow: hidden;'+
        '}'+
          '.radio-unchecked {'+
          'display: inline-block;'+
          'background-image: url("https://erisservice9.erisinfo.com/exreportw/frmimages/radio-unchecked.jpeg");'+
          'background-repeat: no-repeat;'+
          'background-size: 12px 12px;'+
          'padding: 1px 0 0 16px;'+
          ' }'+

          '.radio-checked {'+
          ' display: inline-block;'+
          'background-image: url("https://erisservice9.erisinfo.com/exreportw/frmimages/radio-checked.jpg");'+
          ' background-repeat: no-repeat;'+
          'background-size: 12px 12px;'+
          ' padding: 1px 0 0 16px;'+
          '}'+
          'ul {'+
          'list-style-type: none;'+
          'padding: 0 0 0 0.2rem;'+
          '}'+
  
          'ul li {'+
          'padding: 1px 0 1px 0;'+
          '}'+
  
          'ul ul {'+
          'padding-left: 1.2rem;'+
          '}'+
  
          '.flex,'+
          '.flex3,'+
           '.flex4 {'+
          'display: flex;'+
          'justify-content: space-between;'+
          '}'+
  
          '.flex3 div {'+
          'width: 32%;'+
          '}'+
  
          '.flex4 div {'+
          'width: 23%;'+
          '}'+
  
          '.under-line {'+
            'display: inline-block;'+
           'border-bottom: solid 2px black;'+
           'padding: 0 0.1rem;'+
           '}'+
           '.under-line1 {'+
            'display: inline-block;'+
            'border-bottom: solid 1px black;'+
            'padding: 0 .6rem;'+
            'width:20px;'+
            'text-align:center'+
            'margin-right:4px;'+
            'font-size:11px;'+
            'height:14px;'+
            '}'+
          '.table-title {'+
          'background-color: #fff;'+
          'border-top: double 2px #000;'+
           'border-bottom: solid 2px #000;'+
           'margin: 4px 0;'+
          'font-size: 13px;'+
          'font-weight: bold;'+
          '}'+
  
          '.unit-tables {'+
          'padding-left: 1rem;'+
          '}'+
  
          '.unit-tables table {'+
          'border-width: 0;'+
          '}'+
          '.unit-tables th {'+
          'background-color: transparent;'+
          'border: 0;'+
          'padding: 1px;'+
          '}'+
  
          '.unit-tables td {'+
          'text-align: center;'+
          'padding: 2px;'+
          '}'+
  
          '.unit-tables td.border-none {'+
          'border: 0;'+
          'text-align: right;'+
          'padding-right: 1rem;'+
          '}'+
  
          '.unit-tables tr.border-bottom td {'+
          'border: 0;'+
          'border-bottom: solid 1px black;'+
          'background-image: url("data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=");'+
          'background-size: 5px 6px;'+
          'background-position: bottom right;'+
          'background-repeat: no-repeat;'+
          'text-align: center;'+
          '}'+
  
          '.unit-tables tr.border-bottom td:last-child {'+
          'background-image: none;'+
          '}'+
  
          '.unit-tables thead tr {'+
          'border-top: solid 1px #000;'+
          '}'+
  
          '.unit-tables tfoot tr {'+
          'border-top: solid px #000;'+
          '}'+
  
          '#table2-total {'+
          'border-collapse: separate;'+
          'border-spacing: 2px;'+
          'border: double 2px black;'+
          'width: 95%;'+
          'float: right;'+
          '}'+
  
          '#table2-total td {'+
          'border: 0;'+
          'padding: 1px;'+
          '}'+
  
          '#table2-total td:first-child {'+
          'text-align: right;'+
          'padding-right: 1rem;'+
          '}'+
  
          '#table2-total td:last-child {'+
          'border-bottom: solid 1px black;'+
          '}'+
  
          '.tfoot-table {'+
          'border-collapse: separate;'+
          'border-spacing: 0;'+
          '}'+
  
          '.tfoot-table td {'+
          'border: 0;'+
          'border-top: solid 2px black;'+
          'border-bottom: solid 2px black;'+
          '}'+
          '.frm-graycell{'+
            'background-color: #ccc;'+
          '}'+
          'table.section-header {'+
            'table-layout: fixed;'+
          '}'+
          'table.section-header td div * {'+
            'display: inline;'+
          '}'+
          '.klistItem1{'+
            'width:24%;'+
            'display:inline-block;'+ 
            'text-align:center;'+ 
            ' vertical-align:top;'+
            'margin:2px;'+
            '}'+
            '.klistItem{'+
            'width:74%;'+
            'display:inline-block;'+ 
            'text-align:left;'+ 
            'vertical-align:top;'+
                   
            '}'+
            '.klistItem7{'+
            'width:24%;'+
            'text-align:center;'+ 
            'vertical-align:bottom;'+
            'margin:2px;'+
            '}'+
            '.klistItem8{'+
            'width:74%;'+
            'text-align:left;'+ 
            'vertical-align:bottom;'+
            'margin:2px;'+       
            '}'+
            '.klistItem3{'+
            'width:100px;'+
            'display:inline-block;'+ 
            'text-align:center;'+ 
            'vertical-align:top;'+
            'padding-left:2px;'+
            'margin-top:4px;'+            
            '}'+
            '.klistItem4{'+
            'width:86%;'+
            'display:inline-block;'+ 
            'text-align:left;'+ 
            'vertical-align:top;'+
            'padding-left:2px;'+
            'margin-top:4px;'+                        
            '}'+
            '.klistItem5{'+
            'width:70%;'+
            'text-align:left;'+ 
            'vertical-align:top;'+
            'padding-left:2px;'+
            'margin-top:4px;'+                      
            '}'+
            '.klistItem6{'+
            'width:100px;'+
            'text-align:center;'+ 
            'vertical-align:top;'+
            'margin-top:4px;'+ 
            '}'+
            '.kItem{'+
            'width:64%; '+
            ' text-align: center;'+
            'height:16px; '+
            'font-size: 13px;'+
            '}'+
            '.kItem1{'+
            'width:100%; '+
            'text-align: center;'+
            'height:16px; '+
            'font-size: 13px;'+
            'margin-top:4px;'+
            '}'+
            '.textList p{'+
            'margin:4px 0;'+
            '}'+
            ".leftbox{"+
              'width:118px;'+
              'text-align: center;'+ 
              'margin-left: 33px;'+ 
              'font-size: 10pt'+
            "}"+
            ".totalbox{"+
              'display: flex;'+
              'margin-top: 2px;'+
            "}"+
           ".leftlabel{"+
            'display:flex;'+
            'flex-basis:86%;'+ 
            'justify-content: flex-end'+
          "}"+
          ".leftlabel1{"+
            'display:flex;'+
            'flex-basis:86%;'+ 
            'justify-content: flex-start'+
          "}"+
           ".rightbox{"+
            'display:flex;'+
            'width:90px;'+
            'margin-left: 11.5px;'+
            "justify-content: center"+
          "}"+
          '</style>'+
          '</head>'+
          '<body>'+
          "<main>";
public frm1104content=[
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "I", "SECTION_TITLE": "Section I: General Information, Documentation and Certification","SUB_SECTIONS": [
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Mortgage and Property Information","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-0-0", data:{
      'FrmLoanNo':{'html':'<p><span class=\"placeholder\" data-id=\"75\" data-type=\"text\" data-status=\"N\">{Freddie Mac Loan Number}</span></p>', 'secHtml':{"changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"75\" data-type=\"text\" data-status=\"N\">{Freddie Mac Loan Number}</span></p>"}, "text": "{Freddie Mac Loan Number}"},
      'FinalAsmntDate':'',
      'AsReportedName':{'html':'<p><span class=\"placeholder\" data-id=\"7\" data-type=\"text\" data-status=\"N\">{Property Name}</span></p>', 'secHtml':{"changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"7\" data-type=\"text\" data-status=\"N\">{Property Name}</span></p>"}, "text": "{Property Name}"},
      'AccountName':{'html':'<p><span class=\"placeholder\" data-id=\"73\" data-type=\"text\" data-status=\"N\">{Seller/Servicer Name}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"73\" data-type=\"text\" data-status=\"N\">{Seller/Servicer Name}</span></p>"
    }, "text": "{Seller/Servicer Name}"},
      'AddressLineText':{'html':'<p><span class=\"placeholder\" data-id=\"8\" data-type=\"text\" data-status=\"N\">{Property Address}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"8\" data-type=\"text\" data-status=\"N\">{Property Address}</span></p>"
    }, "text": "{Property Address}"},
      'PartyBusinessAccountId':{'html':'<p><span class=\"placeholder\" data-id=\"74\" data-type=\"text\" data-status=\"N\">{Seller/Servicer Number}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"74\" data-type=\"text\" data-status=\"N\">{Seller/Servicer Number}</span></p>"
    }, "text": "{Seller/Servicer Number}"},
      'CityName':{'html':'<p><span class=\"placeholder\" data-id=\"10\" data-type=\"text\" data-status=\"N\">{Property City}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"10\" data-type=\"text\" data-status=\"N\">{Property City}</span></p>"
    }, "text": "{Property City}"},
      'StateUspsCode':{'html':'<p><span class=\"placeholder\" data-id=\"11\" data-type=\"text\" data-status=\"N\">{Property State/Province}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"11\" data-type=\"text\" data-status=\"N\">{Property State/Province}</span></p>"
    }, "text": "{Property State/Province}"},
      'PostalCode':{'html':'<p><span class=\"placeholder\" data-id=\"12\" data-type=\"text\" data-status=\"N\">{Property Zipcode/Postal Code}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"12\" data-type=\"text\" data-status=\"N\">{Property Zipcode/Postal Code}</span></p>"
    }, "text": "{Property Zipcode/Postal Code}"},
    "discuss":''
      }
    },
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Consultant Information","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-0-1", data:{
      'FirmName':{'html':'<p><span class=\"placeholder\" data-id=\"108\" data-type=\"text\" data-status=\"N\">{Company Name (Consultant)}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"108\" data-type=\"text\" data-status=\"N\">{Company Name (Consultant)}</span></p>"
    }, "text": "{Company Name (Consultant)}"},
      'InspectorName':{'html':'', 'secHtml':null, 'text':''},
      'FirmAddressLineText':{'html':'<p><span class=\"placeholder\" data-id=\"109\" data-type=\"text\" data-status=\"N\">{Company Street Address}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"109\" data-type=\"text\" data-status=\"N\">{Company Street Address}</span></p>"
    }, "text": "{Company Street Address}"},
      'WriterName':{'html':'<p><span class=\"placeholder\" data-id=\"79\" data-type=\"text\" data-status=\"N\">{Writer Name}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"79\" data-type=\"text\" data-status=\"N\">{Writer Name}</span></p>"
    }, "text": "{Writer Name}"},
      'ReviewerName':{'html':'', 'secHtml':null, 'text':''},
      'FirmCityName':{'html':'<p><span class=\"placeholder\" data-id=\"111\" data-type=\"text\" data-status=\"N\">{Company City}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"111\" data-type=\"text\" data-status=\"N\">{Company City}</span></p>"
    }, "text": "{Company City}"},
      'FirmStateUspsCode':{'html':'<p><span class=\"placeholder\" data-id=\"112\" data-type=\"text\" data-status=\"N\">{Company State/Province}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"112\" data-type=\"text\" data-status=\"N\">{Company State/Province}</span></p>"
    }, "text": "{Company State/Province}"},
      'FirmPostalCode':{'html':'<p><span class=\"placeholder\" data-id=\"113\" data-type=\"text\" data-status=\"N\">{Company Zipcode/Postcode}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"113\" data-type=\"text\" data-status=\"N\">{Company Zipcode/Postcode}</span></p>"
    }, "text": "{Company Zipcode/Postcode}"},
      'FirmPhoneNumber':{'html':'<p><span class=\"placeholder\" data-id=\"114\" data-type=\"text\" data-status=\"N\">{Company Telephone #}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"114\" data-type=\"text\" data-status=\"N\">{Company Telephone #}</span></p>"
    }, "text": "{Company Telephone #}"},
      'FirmPhoneExt':{'html':'', 'secHtml':null, 'text':''},
      'VisitDate':'',
      'EngageDate':'',
    }},
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Site Statistics","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-0-2", data:{
      'BuildYear':{'html':'<p><span class=\"placeholder\" data-id=\"42\" data-type=\"text\" data-status=\"N\">{Year(s) Constructed}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"42\" data-type=\"text\" data-status=\"N\">{Year(s) Constructed}</span></p>"
    }, "text": "{Year(s) Constructed}"},
      'RenovYear':{'html':'<p><span class=\"placeholder\" data-id=\"44\" data-type=\"text\" data-status=\"N\">{Year(s) of Substantial Renovation}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"44\" data-type=\"text\" data-status=\"N\">{Year(s) of Substantial Renovation}</span></p>"
    }, "text": "{Year(s) of Substantial Renovation}"},
    'RenovCost':0,
      'BuildingType':{'html':'', 'secHtml':null, 'text':''},
      'Acre':{'html':'<p><span class=\"placeholder\" data-id=\"19\" data-type=\"text\" data-status=\"N\">{Site Acreage/Area}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"19\" data-type=\"text\" data-status=\"N\">{Site Acreage/Area}</span></p>"
    }, "text": "{Site Acreage/Area}"},
      'Topo':{'html':'', 'secHtml':null, 'text':''},
      'FloodZone':{'html':'<p><span class=\"placeholder\" data-id=\"15\" data-type=\"text\" data-status=\"N\">{Flood Zone (FEMA)}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"15\" data-type=\"text\" data-status=\"N\">{Flood Zone (FEMA)}</span></p>"
    }, "text": "{Flood Zone (FEMA)}"},
      'PeakGround':{'html':'<p><span class=\"placeholder\" data-id=\"17\" data-type=\"text\" data-status=\"N\">{Peak Ground Acceleration (PGA)}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"17\" data-type=\"text\" data-status=\"N\">{Peak Ground Acceleration (PGA)}</span></p>"
    }, "text": "{Peak Ground Acceleration (PGA)}"},
      'Amenities':{'html':'', 'secHtml':null, 'text':''},
      'Units':{'html':'<p><span class=\"placeholder\" data-id=\"34\" data-type=\"text\" data-status=\"N\">{Number of Units}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"34\" data-type=\"text\" data-status=\"N\">{Number of Units}</span></p>"
    }, "text": "{Number of Units}"},
      'ApartmentUnits':{'html':'', 'secHtml':null, 'text':''},
      'OtherUnits':{'html':'<p><span class=\"placeholder\" data-id=\"192\" data-type=\"text\" data-status=\"N\">{Number of Other Structures}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"192\" data-type=\"text\" data-status=\"N\">{Number of Other Structures}</span></p>"
    }, "text": "{Number of Other Structures}"},
      'Surface':{'html':'', 'secHtml':null, 'text':''},
      'Garage':{'html':'', 'secHtml':null, 'text':''},
      'Carports':{'html':'', 'secHtml':null, 'text':''},
      'GroundUnits':{'html':'', 'secHtml':null, 'text':''},
      'Elevators':{'html':'', 'secHtml':null, 'text':''},
      'Floors':{'html':'', 'secHtml':null, 'text':''},
      'Other':{'html':'', 'secHtml':null, 'text':''},
      //'feature':'',
    }},
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "List of Parties Present","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-0-3", data:[{
      'Name':{'html':'', 'secHtml':null, 'text':''},
      'Title':{'html':'', 'secHtml':null, 'text':''},
      'Company':{'html':'', 'secHtml':null, 'text':''},
      'Affiliation':{'html':'', 'secHtml':null, 'text':''},
      'Comment':{'html':'', 'secHtml':null, 'text':''},
    }]},
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Documentation","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-0-4", data:
    {
      'documents':['','','','','','','','','','','','',''],
      'additionalInfo':''
    }
    },
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Data Collection and Records Inquiry","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-0-5", data:
    [{'status':'', 'Explanation':''},
      {'status':'', 'Explanation':''},
      {'status':'', 'Explanation':''},
      {'status':'', 'Explanation':''},
      {'status':'', 'Explanation':''}
    ]
    
    },
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Reliance","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-0-6", data:{}},
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Certification","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-0-7", data:{
      'inspector':{
        "sign":'',
        "date":'',
        "name":'',
        "title":'',
      },
      'otherRptReviewer':{
        "required":'',
        "sign":'',
        "date":'',
        "name":'',
        "title":'',

      },
      'otherEvReviewer':{
        "required":'',
        "sign":'',
        "date":'',
        "name":'',
        "title":'',

      }
    }},
  ],'TYPE': "frm1104","id": "frm1104-0"},
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "II", "SECTION_TITLE": "Section II: Unit Details","SUB_SECTIONS": [
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Unit Mix and Inspection","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-1-0", data:{
      "PropertyResidentialUnitMix":[{
        'BedroomCount':"",
        'BathroomCount':"",
        'AvgSquareFeetNumber':"",
        'StyleType':"",
        'PptyUnitTypeOccupiedUnitCount':0,
        'VacantUnitCount':0,
        'PptyUnitTypeDownUnitCount':0,
        'PptyUnitTypeOtherUnitCount':0,
        'PptyUnitTypeOccupiedInspectedUnitCount':0,
        'PptyUnitTypeVacantInspectedUnitCount':0,
        'PptyUnitTypeDownInspectedUnitCount':0,
        'PptyUnitTypeOtherInspectedUnitCount':0,
      }],
      "PropertyResidentialUnitMixTotal":{
        "TotalOccupiedUnitCount":0,
        "TotalVacantUnitCount":0,
        "PptyTotalDownUnitCount":0,
        "TotalOtherUnitCount":0,
        "RsdntlOccupiedInspectedUnitCount":0,
        "RsdntlVacantInspectedUnitCount":0,
        "RsdntlDownInspectedUnitCount":0,
        "RsdntlOtherInspectedUnitCount":0,
      },
      'PropertyCommercialUsageMix':[{
        'OccupiedUnitCount':0,
        'VacantUnitCount':0,
        'DownUnitCount':0,
        'UnitCount':0,
      },
      {
        'OccupiedUnitCount':0,
        'VacantUnitCount':0,
        'DownUnitCount':0,
        'UnitCount':0,
      }],
      "PropertyOtherDetail":{
        "PptyTotalOtherMgmtOfficeUnitCount":0,
        "PptyTotalOtherModelUnitCount":0,
        "PptyTotalOtherMaintenanceShopUnitCount":0,
        "PptyTotalOtherStorageUnitCount":0,
        "PptyTotalOtherHospitalitySuiteUnitCount":0,
        "PptyTotalOtherMiscellaneousUnitCount":0,
      },
      'summary':{
        "RsdntlTotalUnitCount":0, 
        "CommercialTotalUnitCount":0,
        "TotalUnitCount":0,
      },
      'unequal':false,
    }
    },
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Uncertified or Unpermitted Units and/or Modifications","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-1-1", data:{
      'Violations':'',
      'Certified':0,
      'AllUnit':0,
      'ViolationRecord':[
        {
          'Location':'',
          "OnRecord":'',
          "Description":''
        }
      ]
    }
  },
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Unit Inspection Information","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-1-2", data:{
      "PropertyResidentialRentalUnit": [
        {
          "UnitType": "",
          "SlrDesignatedUnitId": "",
          "OccupancyStatusType": ""
        },
        {
          "UnitType": "",
          "SlrDesignatedUnitId": "",
          "OccupancyStatusType": ""
        },
        {
          "UnitType": "",
          "SlrDesignatedUnitId": "",
          "OccupancyStatusType": ""
        },
        {
          "UnitType": "",
          "SlrDesignatedUnitId": "",
          "OccupancyStatusType": ""
         },
		  ],
      "AccessProblems":{
        'status':'',
        "description":''
      }
      }
    },
    
  ],'TYPE': "frm1104","id": "frm1104-1"},
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "III", "SECTION_TITLE": "Section III: Property Condition Assessment","SUB_SECTIONS": [
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Problematic Materials & Conditions","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-2-0", data:{
      "checkItem":['','','','','','','','',''],
      'None':'',
      'other':'',
      'otherDetail':{
        "description":'',
        "condition":"",
        "hasDeficiencies":"",
        "deficiencies":[
          {'cat':'Critical Repairs','type':"crs",
            "status":'',
            "description":'',
            "cost":'',
          },
          {'cat':'PR-90 Repairs','type':"pr90s",
            "status":'',
            "description":'',
            "cost":'',
          },
          {'cat':'Priority Repairs','type':"prs",
            "status":'',
            "description":'',
            "cost":'',
          },
          {'cat':'Operational Repairs','type':"ors",
            "status":'',
            "description":'',
            
          },
          {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

            "status":'',
            "description":'',
            "cost":'',
          },
        ]
      }     
    }
  },
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Safety & Security Devices","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-2-1", data:{
    "checkItem":['','','','','','','','',''],
      'None':'',
      'other':'',
      'otherDetail':{
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs',
          'type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs',
          'type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs',
          'type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs',
          'type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?',

        'type':"adds",
          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }     
  }
},
{"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Property Grounds, Building Exteriors and Systems","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-2-2", data:{
  'intro':"Provide a brief description, including materials and finishes used, of the components pertaining to the Property grounds, building exterior and systems.",
  'sub':[
    {'subcat':"Site Work",
      'otherDetail':{
        "intro":"Including, but not limited to: security, drainage, paving, flatwork, accessibility, lighting, landscaping, irrigation, signage, refuse containment, garages and carports, fencing and retaining walls",
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Roofing",'otherDetail':{
      'intro':"Including, but not limited to: material (including condition and age), parapets, scuppers, drains, gutters and downspouts, flashing and coping, appurtenances",
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Building Façade",'otherDetail':{
      'intro':"Including, but not limited to: building materials, condition, windows, doors, sealants, evidence of water infiltration",
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Structure",'otherDetail':{
      'intro':"Including, but not limited to: foundations, framing systems, balconies and exterior stairs",
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"HVAC Systems",'otherDetail':{
      'intro':"Including, but not limited to: type, fuel source, manufacturer and capacity",
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Plumbing Systems",'otherDetail':{
      'intro':"Including, but not limited to: fixtures, piping materials used, supply system, waste system and vent system",
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Electrical Conditions",'otherDetail':{
      "intro":"Indicate if any of the following electrical conditions are present at the Property:",
      "ifConditions":[
        {"condition":"Electrical service less than 60 amps", 'status':"",
        "questions":[
          {'label':'Has this market been identified as a Freddie Mac SBL Top Market?', 'status':''},
          {'label':'Is electrical service less than 40 amps?', 'status':'', "moreinfo":true, 'info':'What is the level of service?', 'value':'', 'unit':'amps'},
        ],
        "description":{'label':"Describe the results of the load analysis, and identify who completed it:", "text":""},
        "hasDeficiencies":"",
        "deficiencies":[
          {'cat':'Critical Repairs','type':"crs",
            "status":'',
            "description":'',
            "cost":'',
          },
          {'cat':'PR-90 Repairs','type':"pr90s",
            "status":'',
            "description":'',
            "cost":'',
          },
          {'cat':'Priority Repairs','type':"prs",
            "status":'',
            "description":'',
            "cost":'',
          },
          {'cat':'Operational Repairs','type':"ors",
            "status":'',
            "description":'',
            
          },
          {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

            "status":'',
            "description":'',
            "cost":'',
          },
        ]
      },
        {"condition":"Non-GFCI outlets in wet locations", 'status':"",
        "description":{'label':"Description:", "text":""},
        "hasDeficiencies":"",
        "deficiencies":[
          {'cat':'Critical Repairs','type':"crs",
            "status":'',
            "description":'',
            "cost":'',
          },
          {'cat':'PR-90 Repairs','type':"pr90s",
            "status":'',
            "description":'',
            "cost":'',
          },
          {'cat':'Priority Repairs','type':"prs",
            "status":'',
            "description":'',
            "cost":'',
          },
          {'cat':'Operational Repairs','type':"ors",
            "status":'',
            "description":'',
            
          },
          {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

            "status":'',
            "description":'',
            "cost":'',
          },
        ]},
        {"condition":"Overload protection provided by devices other than circuit breakers or S-type fuses", 'status':"N",
        "intro":"Please go to the Problematic Materials and Conditions section at the top of this page for further discussion.",
        },
      ],
      /*"description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]*/
    }
  },
    {'subcat':"Electrical Systems",'otherDetail':{
      'intro':"Including, but not limited to: capacity, fixtures, distribution system and emergency power",
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Elevators",'otherDetail':{
      'intro':"Including, but not limited to: cab, controls and equipment and inspection certifications",
      'ifPresent':{'question':"Are there any elevators?","status":''},
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Amenities",'otherDetail':{
      'intro':"Including, but not limited to: pool, sports courts, playgrounds, club house, laundry room and fitness center",
      'ifPresent':{'question':"Are there any amenities?","status":''},
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Utilities",'otherDetail':{
      'providers':[
        {'label':"Electricity", 'html':'<p><span class="placeholder" data-id="37" data-type="text" data-status="N">{Provider: Electricity}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"37\" data-type=\"text\" data-status=\"N\">{Provider: Electricity}</span></p>"
      }, 'text':'{Provider: Electricity}'},
        {'label':"Natural gas", 'html':'<p><span class="placeholder" data-id="40" data-type="text" data-status="N">{Provider: Natural Gas}</span></p>', 'secHtml':{"changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"40\" data-type=\"text\" data-status=\"N\">{Provider: Natural Gas}</span></p>"
      }, 'text':'{Provider: Natural Gas}'},
        {'label':"Fuel oil", 'html':'<p><span class="placeholder" data-id="38" data-type="text" data-status="N">{Provider: Fuel Oil}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"38\" data-type=\"text\" data-status=\"N\">{Provider: Fuel Oil}</span></p>"
      }, 'text':'{Provider: Fuel Oil}'},
        {'label':"Propane", 'html':'<p><span class="placeholder" data-id="2069" data-type="text" data-status="N">{Provider: Propane}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"2069\" data-type=\"text\" data-status=\"N\">{Provider: Propane}</span></p>"
      }, 'text':'{Provider: Propane}'},
        {'label':"Domestic water", 'html':'<p><span class="placeholder" data-id="2066" data-type="text" data-status="N">{Provider: Domestic Water}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"2066\" data-type=\"text\" data-status=\"N\">{Provider: Domestic Water}</span></p>"
      }, 'text':'{Provider: Domestic Water}'},
        {'label':"Storm sewer", 'html':'<p><span class="placeholder" data-id="2070" data-type="text" data-status="N">{Provider: Storm Sewer}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"2070\" data-type=\"text\" data-status=\"N\">{Provider: Storm Sewer}</span></p>"
      }, 'text':'{Provider: Storm Sewer}'},
        {'label':"Sanitary sewer", 'html':'<p><span class="placeholder" data-id="2067" data-type="text" data-status="N">{Provider: Sanitary Sewer}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"2067\" data-type=\"text\" data-status=\"N\">{Provider: Sanitary Sewer}</span></p>"
      }, 'text':'{Provider: Sanitary Sewer}'},
        {'label':"Cable", 'html':'<p><span class="placeholder" data-id="2071" data-type="text" data-status="N">{Provider: Cable}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"2071\" data-type=\"text\" data-status=\"N\">{Provider: Cable}</span></p>"
      }, 'text':'{Provider: Cable}'},
        {'label':"Internet", 'html':'<p><span class="placeholder" data-id="2068" data-type="text" data-status="N">{Provider: Internet}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"2068\" data-type=\"text\" data-status=\"N\">{Provider: Internet}</span></p>"
      }, 'text':'{Provider: Internet}'},
        {'label':"Telephone", 'html':'<p><span class="placeholder" data-id="2072" data-type="text" data-status="N">{Provider: Telephone}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"2072\" data-type=\"text\" data-status=\"N\">{Provider: Telephone}</span></p>"
      }, 'text':'{Provider: Telephone}'},
        {'label':"Other:", 'html':'', 'secHtml':null, 'text':''},
        {'label':"Other:", 'html':'', 'secHtml':null, 'text':''},
      ],
      //"description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Were any Critical Repairs identified?','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Were any PR-90 Repairs identified?','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Were any Priority Repairs identified?','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Were any Operational Repairs identified?','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Water Infiltration",'otherDetail':{
      'ifPresent':{'question':"Were any water and/or seepage conditions identified that were not discussed previously?","status":''},
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Wells and Septic Systems",'otherDetail':{
      'ifPresent':{'question':"Are there wells or septic systems?","status":''},
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},

  ],
  'otherDetail':{
    "description":'',
    "condition":"",
    "hasDeficiencies":"",
    "deficiencies":[
      {'cat':'Critical Repairs','type':"crs",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'PR-90 Repairs','type':"pr90s",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'Priority Repairs','type':"prs",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'Operational Repairs','type':"ors",
        "status":'',
        "description":'',
        
      },
      {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

        "status":'',
        "description":'',
        "cost":'',
      },
    ]
  }     
}
},
{"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Dwelling Units, Commercial Units and Building Interiors","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-2-3", data:{
  'intro':"Provide a brief description, including materials and finishes used, of the components pertaining to the dwelling units and any commercial units and building interiors/common areas.",
  'sub':[
    {'subcat':"Floors, Walls & Ceilings",'otherDetail':{
      'intro':"Including, but not limited to: carpet, vinyl, tile, wall board, plaster and any textures",
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Doors & Windows",'otherDetail':{
      'intro':"Including, but not limited to: hardware, locks, treatments, screens and storm windows",
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Kitchens",'otherDetail':{
      'intro':"Including, but not limited to: cabinets, countertops and appliances",
      "description":'',
      "condition":"",
      "detailQuestion":[
        {"question":'Is there a refrigerator of at least 2.2 cubic feet in all units?', 'status':'', 'sub':{'label':"Is this common for the marketplace?","status":"", 'sub':{'label':"Is there space and an outlet available for a refrigerator?","status":"", "costs":[{"description":'How many units are affected by this?', "cost":''}, {"description":"What is the cost/unit to cure?", "cost":""}]}}},
        {"question":'Is there counter space with an installed sink in all units?', 'status':'', "costs":[{"description":'How many units are affected by this?', "cost":''}, {"description":"What is the cost/unit to cure?", "cost":""}]},
        {"question":'Is there a permanent stove-top with at least two burners in all units?', 'status':'', "costs":[{"description":'How many units are affected by this?', "cost":''}, {"description":"What is the cost/unit to cure?", "cost":""}]},
      ],
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Bathrooms",'otherDetail':{
      'intro':"Including, but not limited to: cabinets, countertops, sinks, toilets and bathtubs/shower stalls",
      "description":'',
      "condition":"",
      "detailQuestion":[
        {"question":'Is there at least one bathroom in all units with a toilet, sink and bath tub or shower stall?', 'status':'', "costs":[{"description":'How many units are affected by this?', "cost":''}, {"description":"What is the cost/unit to cure?", "cost":""}]},
      ],
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Fireplaces",'otherDetail':{
      'ifPresent':{'question':"Are fireplaces located in the units?","status":''},
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"In-Unit Washer and Dryers",'otherDetail':{
      'ifPresent':{'question':"Are washer/dryer units or hook-ups provided in the units?","status":''},
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Commercial Spaces",'otherDetail':{
      'ifPresent':{'question':"Are commercial spaces present?","status":''},
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }},
    {'subcat':"Common Spaces",'otherDetail':{
      "intro":"Including, but not limited to: lobbies, corridors, stairs, offices, laundry and garages",
      'ifPresent':{'question':"Are common spaces present?","status":''},
      "description":'',
      "condition":"",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }}
  ],
  'otherDetail':{
    "description":'',
    "condition":"",
    "hasDeficiencies":"",
    "deficiencies":[
      {'cat':'Critical Repairs','type':"crs",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'PR-90 Repairs','type':"pr90s",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'Priority Repairs','type':"prs",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'Operational Repairs','type':"ors",
        "status":'',
        "description":'',
        
      },
      {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

        "status":'',
        "description":'',
        "cost":'',
      },
    ]
  }     
}
},
{"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Other","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-2-4", data:{
  "ifcover":
    {"label":"Are there any components not covered in the previous section that need to be discussed?", "status":"", "description":''},     
  'other':'',
  'otherDetail':{
    "description":'',
    "condition":"",
    "hasDeficiencies":"",
    "deficiencies":[
      {'cat':'Critical Repairs','type':"crs",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'PR-90 Repairs','type':"pr90s",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'Priority Repairs','type':"prs",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'Operational Repairs','type':"ors",
        "status":'',
        "description":'',
        
      },
      {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

        "status":'',
        "description":'',
        "cost":'',
      },
    ]
  }     
}
},{"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Wood Damaging Insects","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-2-5", data:{
  "issues":[
    {"label":"Were inquiries made of knowledgeable staff regarding past or current wood-damaging insects (WDI) issues?", "status":"", "description":''},
    {"label":"Were any signs of WDIs observed during the inspection?", "status":"", "description":''}
  ],
  'other':'',
  'otherDetail':{
    //"description":'',
    "condition":"",
    "hasDeficiencies":"",
    "deficiencies":[
      {'cat':'Critical Repairs','type':"crs",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'PR-90 Repairs','type':"pr90s",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'Priority Repairs','type':"prs",
        "status":'',
        "description":'',
        "cost":'',
      },
      {'cat':'Operational Repairs','type':"ors",
        "status":'',
        "description":'',
        
      },
      {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

        "status":'',
        "description":'',
        "cost":'',
      },
    ]
  }     
}
},{"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Fair Housing","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-2-6", data:{
  'laws':{'label':'Is the Property subject to Fair Housing laws?', 'status':'', },
  'detail':{'label':'Did the Property generally appear to be in compliance with Fair Housing?', 'status':''},
  "description":'',
  "deficiencies":[
      {'cat':'Critical Repair','type':"crs","status":''},
      /*{'cat':'PR-90 Repairs','type':"pr90s",
      "status":'',
      "description":'',
      "cost":'',
    },*/
      {'cat':'Priority Repair','type':"prs","status":''},
      {'cat':'Operational Repair','type':"ors","status":''},
      {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",
"status":''}, 
    ]      
}
},{"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "ADA","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-2-7", data:{
  'laws':{'label':'Is the Property subject to the Americans with Disabilities Act?', 'status':'', },
  'detail':{'label':'Did the ADA Tier 1 study of the Property reveal any areas of non-conformance?', 'status':'', "description":'',},
  "needRepair":{'label':'Are any repairs required that would increase accessibility for handicapped tenants and are deemed readily  achievable and qualify as reasonable accommodations?', 'status':'', 'description':''},
  "description":'',
  "deficiencies":[
      {'cat':'Critical Repair','type':"crs","status":''},
      {'cat':'Priority Repair','type':"prs","status":''},
     /* {'cat':'PR-90 Repairs','type':"pr90s",
      "status":'',
      "description":'',
      "cost":'',
    },*/
      {'cat':'Operational Repair','type':"ors","status":''},
      {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",
"status":''}, 
    ]      
}
},{"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Violations","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-2-8", data:{
  'violationCount':"",
  "description" :"",
  "list":[],
  "baserow":{"description":"", "status":"", "cost":''},  
}
},
{"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Capital Improvements","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-2-9", data:{
  "list":[],
  "baserow":{"description":"", "status":"", "cost":''}, 
}
},
  ],'TYPE': "frm1104","id": "frm1104-2"},
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "IV", "SECTION_TITLE": "Section IV: Environmental Site Assessment","SUB_SECTIONS": [
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Environmental Summary","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-3-0", data:{
      "summary":[
        {'label':"Hazardous materials", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "notacceptable":"N"},
        {'label':"Storage tanks", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "notacceptable":"N"},
        {'label':"Polychlorinated biphenyls (PCBs)", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "notacceptable":"N"},
        {'label':"Prior use", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "notacceptable":"N"},
        {'label':"Neighborhood hazardous waste activity", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "notacceptable":"N"},
        {'label':"Asbestos-containing materials (ACM)", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "notacceptable":"N"},
        {'label':"Lead-based paint (LBP)", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "notacceptable":"N"},
        {'label':"Drinking water quality", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "notacceptable":"N"},
        {'label':"Mold", "acceptable":"N", "requireMMP":"N", "notacceptable":"N"},
  
      ],
      "law":{"label":'Does the law of the Property Jurisdiction provide for an "environmental superlien law?"', "status":""},
      "questions":[
        {"label":"Provide details below regarding the concern identified for hazardous materials:","description":"", "required":0, 'field':"notacceptable"},
        {"label":"Provide details below regarding the testing requirements for hazardous materials:","description":"", "required":0, 'field':'requireFurther'},
        {"label":"Provide details below regarding the concern identified for storage tanks:","description":"", "required":1, 'field':"notacceptable"},
        {"label":"Provide details below regarding the testing requirements for storage tanks:","description":"", "required":1, 'field':'requireFurther'},
        {"label":"Provide details below regarding the concern identified for polychlorinated biphenyls (PCBs):","description":"", "required":2, 'field':"notacceptable"},
        {"label":"Provide details below regarding the testing requirements for polychlorinated biphenyls (PCBs):","description":"", "required":2, 'field':'requireFurther'},
        {"label":"Provide details below regarding the concern identified for prior use:","description":"", "required":3, 'field':"notacceptable"},
        {"label":"Provide details below regarding the testing requirements for prior use:","description":"", "required":3, 'field':'requireFurther'},
        {"label":"Provide details below regarding the concern identified for neighborhood hazardous waste activity:","description":"", "required":4, 'field':"notacceptable"},
        {"label":"Provide details below regarding the testing requirements for neighborhood hazardous waste activity:","description":"", "required":4, 'field':'requireFurther'},
        {"label":"Provide details below regarding the concern identified for drinking water quality:","description":"", "required":7, 'field':"notacceptable"},
        {"label":"Provide details below regarding the testing requirements for drinking water quality:","description":"", "required":7, 'field':'requireFurther'},        
      ],
      "discuss":[
        {"label":"<p>Discuss asbestos in the <i>Asbestos</i> section below.</p>","description":"", "required":5, 'field':"notacceptable"},
        {"label":"<p>Discuss asbestos testing requirements in the <i>Asbestos</i> section below.</p>","description":"", "required":5, 'field':"requireFurther"},
        {"label":"<p>Discuss lead-based paint in the <i>Lead-Based Paint</i> section below.</p>","description":"", "required":6, 'field':"notacceptable"},
        {"label":"<p>Discuss lead-based paint testing requirements in the <i>Lead-Based Paint</i> section below.</p>","description":"", "required":6, 'field':"requireFurther"},
        {"label":"<p>Discuss mold in the <i>Mold</i> section below.</p>","description":"", "required":8, 'field':"notacceptable"},
      ]
      },
    },
  
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "E1528 Transaction Screen Questionnaire","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-3-1", data:{
    "issues":[
      {"label":'Were any of the responses in the transaction screen or government records/historical sources answered with "Yes" or "Unknown"?', "status":""},
      {"label":'Did the "Yes" or "Unknown" responses in the transaction screen or government records/historical sources reveal any areas of concern?', "status":"", "moreinfo":true,  "description":''}
    ],
    'other':[
      {"label":'Was an additional investigation required?', "status":""}
    ],
    'otherDetail':{
      "label":"Did the investigation(s) identify any deficiencies that could be categorized as a Critical, PR-90, or Priority Repair?",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        /*{'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },*/
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    }  
  }
  },
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Asbestos","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-3-2", data:
    [{"issues":[
      {"label":'Were any suspect friable materials identified?', "status":"", "materials":[{"location":'', "condition":'', "disturbance":''}], "baserow":{"location":'', "condition":'', "disturbance":''}},
      {"label":'Were any damaged materials observed?', "status":""},
      {"label":'Was there previous testing completed on any of the damaged materials?', "status":"","moreinfo":true,  "description":'', "descriptionLabel":"Discuss the findings:"},
      {"moreinfo":true,  "description":''}
    ],
    'other':[
      {"label":'Was an additional investigation required?', "status":""}
    ],
    'otherDetail':{
      "label":"Were any deficiencies identified that could be categorized as a Critical, PR-90 or Priority Repairs?",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
       /* {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },*/
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    },},
    {"issues":[
      {"label":'Were any suspect non-friable materials identified?', "status":"", "materials":[{"location":'', "condition":'', "disturbance":''}], "baserow":{"location":'', "condition":'', "disturbance":''}},
      {"label":'Were any damaged materials observed?', "status":"","moreinfo":true,  "description":'', "descriptionLabel":"Discuss the findings:"},
      {"label":'Are the damaged materials among those listed in the Green Book as suspect ACMs?', "status":"","moreinfo":true,  "description":'', "descriptionLabel":"Identify which ones:"},      
      {"moreinfo":true,  "description":''}
    ],
    'other':"",
    'otherDetail':{
      "label":"Were any deficiencies identified that could be categorized as a Critical, PR-90 or Priority Repairs?",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
       /* {'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },*/
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    } }] 
  
  },
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Lead-Based Paint","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-3-3", data:{
    "issues":[
      {"label":'Was the original Certification of Occupancy (or legal equivalent) issued prior to January 1, 1978?', "status":"", "materials":[{"location":'', "condition":''}], "baserow":{"location":'', "condition":''}, "descriptionLabel":"Description of paint and locations:"},
           
    ],
    'other':"",
    'otherDetail':{
      "label":"Did the investigation(s) identify any deficiencies that could be categorized as a Critical, PR-90, or Priority Repair?",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        /*{'cat':'Operational Repairs','type':"ors",
          "status":'',
          "description":'',
          
        },*/
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    } 
  }
  },
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Mold","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-3-4", data:{
    "issues":[
      {"label":'Were the following tasks completed during the site investigation?', "status":"", "description":"", "descriptionLabel":"Explain why not:", 
    "items":[
      "Search for visual or olfactory evidence or Mold issues in all areas required to be inspected as set forth in the Guide?",
      "Make inquiries of the Property owner, management or other knowledgeable Property staff regarding past and current water instrusion,",
      "Make inquiries of the Property owner, manager or other knowledgeable Property staff about whether there have been any tenant",
      "Inspect areas where water intrusion or leaks were reported?",
      "Inspect all building components or areas most typically associated with water instrusion or potentially damaging leaks?",
      "Identify any defective building condition that would likely lead to future water instrusion or leaks?",
    ]},
           
    ],
    'other':[
      {"label":'Was any mold identified?', "status":"", "description":"", "descriptionLabel":"Description:"}
    ],
    'otherDetail':{
      "label":"How should this deficiency be addressed?",
      "hasDeficiencies":"",
      "deficiencies":[
        {'cat':'Critical Repairs?','type':"crs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'PR-90 Repairs?','type':"pr90s",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Priority Repairs?','type':"prs",
          "status":'',
          "description":'',
          "cost":'',
        },
        {'cat':'Operational Repairs?','type':"ors",
          "status":'',
          "description":'',
          
        },
        {'cat':'Do any deficiencies require an additional investigation in order to fully develop a repair scope?','type':"adds",

          "status":'',
          "description":'',
          "cost":'',
        },
      ]
    } 
  }
  },],'TYPE': "frm1104","id": "frm1104-3"},
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "V", "SECTION_TITLE": "Section V: List of Repairs and Capital Needs Over the Loan Term","SUB_SECTIONS":[
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Summary of Repairs and Violations","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-4-0", data:{
      "intro":"List each item that can be categorized as a Critical, Priority or Operational Repair. Provide a detailed description for each item (including location of the deficiency) and the cost to cure.",
     "summarylabel":[
        {'label':'Additional Investigation(s)','field':'adds', "cols":['Location','Description','Cost'], 'rows':['location','description', 'cost'], 'space':['22%','67%','11%'],'total':0},
        {'label':'Critical Repair(s)','field':'crs', "cols":['Location','Description','Cost'], 'rows':['location','description', 'cost'], 'space':['22%','67%','11%'],'total':0},
        {'label':'PR-90 Repair(s)','field':'pr90s', "cols":['Location','Description','Cost'], 'rows':['location','description', 'cost'], 'space':['22%','67%','11%'],'total':0},
        {'label':'Priority Repair(s)','field':'prs', "cols":['Location','Description','Cost'], 'rows':['location','description', 'cost'], 'space':['22%','67%','11%'],'total':0},
        {'label':'Operational Repair(s)','field':'ors', "cols":['Location','Description'], 'rows':['location','description'], 'space':['22%','78%']},
      ],
      "summarydata":{
        'adds':[],
        'crs':[],
        'pr90s':[],
        'prs':[],
        'ors':[],
      }      
    }},
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Repair Costs","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-4-1", data:{
      "label":"Were any costs for repair work provided by a third-party source (other than costing manuals)?","status":"","description":"", "descriptionLabel":"Provide details regarding the source and the adequacy of the scope of work to address the deficiencies identified:"
    }},
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Overall Property Condition Rating/Capital Needs Over the Loan Term","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-4-2", data:{
      "intro":"Based on the condition of the Property, determine the reserve level based on the guidance below and provide support for why this level was chosen.",
      "rate":'', "description":"", "descriptionLabel":"Provide backup for why this level was chosen:"
    }}],'TYPE': "frm1104","id": "frm1104-4"},
  {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "VI", "SECTION_TITLE": "Section VI: Definitions","SUB_SECTIONS":[
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Component Conditions","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-5-0", data:{}},
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Repair Categories","SUB_SECTIONS": [],'TYPE': "frm1104","id": "frm1104-5-1", data:{}},
  ],'TYPE': "frm1104","id": "frm1104-5"},
  ]
  public frm1103content=[
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Section I: Summary","SUB_SECTIONS": [
      {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Mortgage, Consultant and Property Information","SUB_SECTIONS": [],'TYPE': "frm1103","id": "frm1103-0-0", data:{
        'FrmLoanNo':{'html':'<p><span class=\"placeholder\" data-id=\"75\" data-type=\"text\" data-status=\"N\">{Freddie Mac Loan Number}</span></p>', 'secHtml':{"changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"75\" data-type=\"text\" data-status=\"N\">{Freddie Mac Loan Number}</span></p>"}, "text": "{Freddie Mac Loan Number}"},
        'FinalAsmntDate':'',
        'AsReportedName':{'html':'<p><span class=\"placeholder\" data-id=\"7\" data-type=\"text\" data-status=\"N\">{Property Name}</span></p>', 'secHtml':{"changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"7\" data-type=\"text\" data-status=\"N\">{Property Name}</span></p>"}, "text": "{Property Name}"},
        'AccountName':{'html':'<p><span class=\"placeholder\" data-id=\"73\" data-type=\"text\" data-status=\"N\">{Seller/Servicer Name}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"73\" data-type=\"text\" data-status=\"N\">{Seller/Servicer Name}</span></p>"
      }, "text": "{Seller/Servicer Name}"},
        'AddressLineText':{'html':'<p><span class=\"placeholder\" data-id=\"8\" data-type=\"text\" data-status=\"N\">{Property Address}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"8\" data-type=\"text\" data-status=\"N\">{Property Address}</span></p>"
      }, "text": "{Property Address}"},
        'PartyBusinessAccountId':{'html':'<p><span class=\"placeholder\" data-id=\"74\" data-type=\"text\" data-status=\"N\">{Seller/Servicer Number}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"74\" data-type=\"text\" data-status=\"N\">{Seller/Servicer Number}</span></p>"
      }, "text": "{Seller/Servicer Number}"},
        'CityName':{'html':'<p><span class=\"placeholder\" data-id=\"10\" data-type=\"text\" data-status=\"N\">{Property City}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"10\" data-type=\"text\" data-status=\"N\">{Property City}</span></p>"
      }, "text": "{Property City}"},
        'StateUspsCode':{'html':'<p><span class=\"placeholder\" data-id=\"11\" data-type=\"text\" data-status=\"N\">{Property State/Province}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"11\" data-type=\"text\" data-status=\"N\">{Property State/Province}</span></p>"
      }, "text": "{Property State/Province}"},
        'PostalCode':{'html':'<p><span class=\"placeholder\" data-id=\"12\" data-type=\"text\" data-status=\"N\">{Property Zipcode/Postal Code}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"12\" data-type=\"text\" data-status=\"N\">{Property Zipcode/Postal Code}</span></p>"
      }, "text": "{Property Zipcode/Postal Code}"},
      'FirmName':{'html':'<p><span class=\"placeholder\" data-id=\"108\" data-type=\"text\" data-status=\"N\">{Company Name (Consultant)}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"108\" data-type=\"text\" data-status=\"N\">{Company Name (Consultant)}</span></p>"
    }, "text": "{Company Name (Consultant)}"},
      'InspectorName':{'html':'<p><span class="placeholder" data-id="2057" data-type="text" data-status="N">{Inspector Name}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": '<p><span class="placeholder" data-id="2057" data-type="text" data-status="N">{Inspector Name}</span></p>'
    }, 'text':'{Inspector Name}'},
      'FirmAddressLineText':{'html':'<p><span class=\"placeholder\" data-id=\"109\" data-type=\"text\" data-status=\"N\">{Company Street Address}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"109\" data-type=\"text\" data-status=\"N\">{Company Street Address}</span></p>"
    }, "text": "{Company Street Address}"},
      'OnsiteName':{'html':'<p><span class=\"placeholder\" data-id=\"49\" data-type=\"text\" data-status=\"N\">{Site Contact Name}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"49\" data-type=\"text\" data-status=\"N\">{Site Contact Name}</span></p>"
    }, "text": "{Site Contact Name}"},
    'OnsiteTitle':{'html':'<p><span class=\"placeholder\" data-id=\"50\" data-type=\"text\" data-status=\"N\">{Site Contact Title}</span></p>', 'secHtml':{
      "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"50\" data-type=\"text\" data-status=\"N\">{Site Contact Title}</span></p>"
  }, "text": "{Site Contact Title}"},
  'OnsitePhoneNo':{'html':'<p><span class=\"placeholder\" data-id=\"51\" data-type=\"text\" data-status=\"N\">{Site Contact Telephone # }</span></p>', 'secHtml':{
    "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"51\" data-type=\"text\" data-status=\"N\">{Site Contact Telephone # }</span></p>"
}, "text": "{Site Contact Telephone # }"},
      'ReviewerName':{'html':'', 'secHtml':null, 'text':''},
      'FirmCityName':{'html':'<p><span class=\"placeholder\" data-id=\"111\" data-type=\"text\" data-status=\"N\">{Company City}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"111\" data-type=\"text\" data-status=\"N\">{Company City}</span></p>"
    }, "text": "{Company City}"},
      'FirmStateUspsCode':{'html':'<p><span class=\"placeholder\" data-id=\"112\" data-type=\"text\" data-status=\"N\">{Company State/Province}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"112\" data-type=\"text\" data-status=\"N\">{Company State/Province}</span></p>"
    }, "text": "{Company State/Province}"},
      'FirmPostalCode':{'html':'<p><span class=\"placeholder\" data-id=\"113\" data-type=\"text\" data-status=\"N\">{Company Zipcode/Postcode}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"113\" data-type=\"text\" data-status=\"N\">{Company Zipcode/Postcode}</span></p>"
    }, "text": "{Company Zipcode/Postcode}"},
      'FirmPhoneNumber':{'html':'<p><span class=\"placeholder\" data-id=\"114\" data-type=\"text\" data-status=\"N\">{Company Telephone #}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"114\" data-type=\"text\" data-status=\"N\">{Company Telephone #}</span></p>"
    }, "text": "{Company Telephone #}"},
      'FirmPhoneExt':{'html':'', 'secHtml':null, 'text':''},
      'VisitDate':'',
      'EngageDate':'',
      'Units':{'html':'<p><span class=\"placeholder\" data-id=\"34\" data-type=\"text\" data-status=\"N\">{Number of Units}</span></p>', 'secHtml':{
        "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"34\" data-type=\"text\" data-status=\"N\">{Number of Units}</span></p>"
    }, "text": "{Number of Units}"},
    'GroundUnits':{'html':'<p><span class="placeholder" data-id="2064" data-type="text" data-status="N">{Number of Ground Floor Units}</span></p>', 'secHtml':{
      "changingThisBreaksApplicationSecurity": '<p><span class="placeholder" data-id="2064" data-type="text" data-status="N">{Number of Ground Floor Units}</span></p>'
  }, "text": "{Number of Ground Floor Units}"},
    'BuildYear':{'html':'<p><span class=\"placeholder\" data-id=\"42\" data-type=\"text\" data-status=\"N\">{Year(s) Constructed}</span></p>', 'secHtml':{
      "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"42\" data-type=\"text\" data-status=\"N\">{Year(s) Constructed}</span></p>"
  }, "text": "{Year(s) Constructed}"},
  'ApartmentUnits':{'html':'<p><span class="placeholder" data-id="2060" data-type="text" data-status="N">{Number of Apartment Buildings}</span></p>', 'secHtml':{
    "changingThisBreaksApplicationSecurity": '<p><span class="placeholder" data-id="2060" data-type="text" data-status="N">{Number of Apartment Buildings}</span></p>'
}, "text": "{Number of Apartment Buildings}"},   
    }
      },
      {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Environmental Report Results","SUB_SECTIONS": [],'TYPE': "frm1103","id": "frm1103-0-1", data:{
        "summary":[
          {'label':"Hazardous materials", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "cost":"", "sectionNo":"", "pageNo":""},
          {'label':"Storage tanks", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "cost":"", "sectionNo":"", "pageNo":""},
          {'label':"Polychlorinated biphenyls (PCBs)", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "cost":"", "sectionNo":"", "pageNo":""},
          {'label':"Prior use", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "cost":"", "sectionNo":"", "pageNo":""},
          {'label':"Neighborhood hazardous waste activity", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "cost":"", "sectionNo":"", "pageNo":""},
          {'label':"Asbestos-containing materials (ACM)", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "cost":"", "sectionNo":"", "pageNo":""},
          {'label':"Lead-based paint (LBP)", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "cost":"", "sectionNo":"", "pageNo":""},
          {'label':"Drinking water quality", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "cost":"", "sectionNo":"", "pageNo":""},
          {'label':"Mold", "acceptable":"N", "requireMMP":"N", "cost":"", "sectionNo":"", "pageNo":""},
          {'label':"Radon", "acceptable":"N", "requireOM":"N", "requireFurther":"N", "cost":"", "sectionNo":"", "pageNo":""},
    
        ],
        "law":{"label":'Does the law of the Property Jurisdiction provide for an "environmental superlien?"', "status":""},
      }},
     ],'TYPE': "frm1103","id": "frm1103-0"},
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Section II: Private Wells, Radon and Attachments","SUB_SECTIONS": [
      {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Private Wells","SUB_SECTIONS": [],'TYPE': "frm1103","id": "frm1103-1-0", data:{
        "label":"Are there private wells at the property used for drinking water?", "status":"","info":"",
        "label2":"What is the date of the most recent drinking water quality test?", "date":"","label3":"Discuss test results below:"
      }
      },
      {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Radon","SUB_SECTIONS": [],'TYPE': "frm1103","id": "frm1103-1-1", data:{
        "label":"Were radon data elements reported to the designated data collection website?", "status":"", "info":"",
      }
    },
      {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Attachments","SUB_SECTIONS": [],'TYPE': "frm1103","id": "frm1103-1-2", data:{
        "Attachments":[
          {"label":"Property inspection photographs:", "status":"", "info":""},
          {"label":"Asbestos sample analysis:", "status":"", "info":""},
          {"label":"Lead-based paint sample analysis:", "status":"", "info":""},
          {"label":"Radon test results:", "status":"", "info":""},
          {"label":"Aerial photographs:", "status":"", "info":""},
          {"label":"Sanborn maps:", "status":"", "info":""},
          {"label":"Other comments:", "status":"", "info":""},

        ]
        }
      },
      
    ],'TYPE': "frm1103","id": "frm1103-1"},
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Section III: Unit Inspection and Certification","SUB_SECTIONS": [
      {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Units Inspected","SUB_SECTIONS": [],'TYPE': "frm1103","id": "frm1103-2-0", data:{
          "units":[],
      }
    },
    {"DISPLAY_SEQUENCE":"N","SECTION_SEQUENCE": "", "SECTION_TITLE": "Consultant's Certification","SUB_SECTIONS": [],'TYPE': "frm1103","id": "frm1103-2-1", data:{
        "sign":"","name":"", "title":"", "date":"","firm":{'html':'<p><span class=\"placeholder\" data-id=\"108\" data-type=\"text\" data-status=\"N\">{Company Name (Consultant)}</span></p>', 'secHtml':{
          "changingThisBreaksApplicationSecurity": "<p><span class=\"placeholder\" data-id=\"108\" data-type=\"text\" data-status=\"N\">{Company Name (Consultant)}</span></p>"
      }, "text": "{Company Name (Consultant)}"}
      }
    },
  
    ],'TYPE': "frm1103","id": "frm1103-2"},
   
    ]
  constructor() { }
}
